<template>
    <div class="complaint-system">
        <div class="page-title" style="margin-bottom: 5px;font-size: 25px; color: #2193b0">客服工单登记</div>

        <!-- 添加一个统一的表单容器 -->
        <div class="form-container">
            <el-form :model="formData" :rules="rules" ref="complaintForm" label-width="120px">
                <el-row :gutter="20" class="form-row">
                    <!-- 投诉来源 -->
                    <el-col :span="8">
                        <!-- <div class="form-section"> -->
                        <!-- <div class="section-title">
                            <i class="el-icon-message"></i>
                            投诉来源
                        </div> -->
                        
                        <el-form-item label="来源渠道" prop="sourceChannel" required>
                            <template slot="label">
                                <i class="el-icon-message"></i>
                                来源渠道
                            </template>
                            <el-select 
                                v-model="formData.sourceChannel" 
                                placeholder="请选择来源渠道" 
                                style="width: 100%"
                                @change="handleSourceChannelChange">
                                <el-option 
                                    v-for="item in sourceChannelList" 
                                    :key="item.itemValue"
                                    :label="item.itemLabel" 
                                    :value="item.itemValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- </div> -->
                    </el-col>

                    <!-- 投诉级别 -->
                    <el-col :span="8">
                        <!-- <div class="form-section"> -->
                        <!-- <div class="section-title">
                            <i class="el-icon-warning"></i>
                            投诉级别
                        </div> -->
                        <el-form-item label="紧急程度" prop="urgencyLevel" required>
                            <template slot="label">
                                <i class="el-icon-warning"></i>
                              紧急程度
                            </template>
                            <el-radio-group v-model="formData.urgencyLevel" class="radio-group" disabled>
                                <el-radio v-for="item in urgencyLevelList" 
                                         :key="item.itemValue"
                                         :label="item.itemValue">
                                    {{ item.itemLabel }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- </div> -->
                    </el-col>

                    <!-- 处理时效 -->
                    <el-col :span="8">
                        <el-form-item label="处理时效" prop="processTime">
                            <template slot="label">
                                <i class="el-icon-time"></i>
                                处理时效
                            </template>
                            <div class="time-input-wrapper">
                                <el-input
                                    v-model="formData.processTimeText"
                                    disabled
                                    :placeholder="getProcessTimeText(formData.urgencyLevel)">
                                    <template slot="append">
                                        <el-tooltip
                                            :content="getProcessTimeTooltip(formData.urgencyLevel)"
                                            placement="top">
                                            <i class="el-icon-info"></i>
                                        </el-tooltip>
                                    </template>
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 投诉时间 -->
                <div class="form-section">
                    <!-- <div class="section-title">
                        <i class="el-icon-time"></i>
                        投诉时间
                    </div> -->
                    <el-row :gutter="20" class="time-row">
                        <el-col :span="8">
                            <!-- 投诉项目 -->
                            <el-form-item label="投诉项目" prop="complaintItem" required>
                                <template slot="label">
                                    <i class="el-icon-document">
                                        投诉项目
                                    </i>
                                </template>
                                <el-cascader v-model="formData.complaintItem" :options="complaintOptions" :props="{
                                    checkStrictly: true,
                                    expandTrigger: 'click',
                                    emitPath: false
                                }" @change="handleComplaintChange" placeholder="请选择投诉项目" clearable class="custom-cascader">
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="创建时间" prop="complaintTime" required>
                                <template slot="label">
                                    <i class="el-icon-time"></i>
                                    创建时间
                                </template>
                                <div class="time-input-wrapper">
                                    <el-date-picker v-model="formData.complaintTime" type="datetime"
                                        placeholder="选择创建时间" format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%">
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="问题时间" prop="issueTime">
                                <template slot="label">
                                    <i class="el-icon-time"></i>
                                    问题时间
                                </template>
                                <div class="time-input-wrapper">
                                    <el-date-picker v-model="formData.issueTime" type="datetime" placeholder="选择问题发生时间"
                                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="issueTimeOptions" style="width: 100%">
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 投诉用户和其他信息 -->
                <el-row :gutter="20" class="form-row">
                    <!-- 投诉用户 -->
                    <el-col :span="12">
                        <!-- <div class="form-section equal-height"> -->
                        <!-- <div class="section-title">
                            <i class="el-icon-user"></i>
                            投诉用户
                        </div> -->
                        <div class="form-content-wrapper">
                            <el-form-item label="电话号码" prop="phoneNumber">
                                <template slot="label">
                                    <i class="el-icon-phone"></i>
                                    电话号码
                                </template>
                                <el-input v-model="formData.phoneNumber" placeholder="请输入电话号码"></el-input>
                            </el-form-item>
                            <el-form-item label="ICCID" prop="userIccid">
                                <template slot="label">
                                    <i class="el-icon-cpu"></i>
                                    ICCID
                                </template>
                                <el-input 
                                    v-model="formData.userIccid" 
                                    placeholder="请输入用户ICCID"
                                    @blur="handleIccidBlur"
                                    @change="handleIccidChange">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="通道编码" prop="userChannelCode">
                                <template slot="label">
                                    <i class="el-icon-connection"></i>
                                    通道编码
                                </template>
                                <el-input v-model="formData.userChannelCode" placeholder="请输入用户通道编码"></el-input>
                            </el-form-item>
                        </div>
                        <!-- </div> -->
                    </el-col>

                    <!-- 右侧信息整合 -->
                    <el-col :span="12">
                        <!-- <div class="form-section equal-height"> -->
                        <!-- 用户类型 -->
                        <!-- <div class="section-title">
                            <i class="el-icon-user-solid"></i>
                            用户类型
                        </div> -->
                        <el-form-item label="用户类型" prop="userType">
                            <template slot="label">
                                <i class="el-icon-user-solid"></i>
                                用户类型
                            </template>
                            <el-radio-group v-model="formData.userType">
                                <el-radio label="1302000">套餐用户</el-radio>
                                <el-radio label="1301000">非套餐用户</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <!-- 代理商信息 -->
                        <el-form-item label="代理商名称" prop="agentName">
                            <template slot="label"> 
                                <i class="el-icon-office-building"></i>
                                代理商信息
                            </template>
                            <el-input v-model="formData.agentName" placeholder="请输入代理商名称"></el-input>
                        </el-form-item>

                        <!-- 问题描述 -->
                        <el-form-item label="问题描述" prop="description">
                            <template slot="label">
                                <i class="el-icon-document"></i>
                                问题描述
                            </template>
                            <el-input
                                type="textarea"
                                v-model="formData.description"
                                :autosize="{ minRows: 1, maxRows: 5 }"
                                placeholder="请详细描述问题..."
                                class="description-textarea"
                            >
                            </el-input>
                        </el-form-item>
                        <!-- </div> -->
                    </el-col>
                </el-row>

                <!-- 团队类型和处理类型放在一起 -->
                <el-row :gutter="24" class="form-row">

                    <div class="form-section">
                        <el-col :span="12">
                            <!-- <div class="section-title">
                                <i class="el-icon-s-operation"></i>
                                团队
                            </div> -->
                            <!-- 团队类型 -->
                            <el-form-item label="团队类型" prop="teamType" required>
                                <template slot="label">
                                    <i class="el-icon-s-operation"></i>
                                    团队
                                </template>
                                <el-cascader v-model="formData.teamType" :options="teamTypeList" :props="{
                                    checkStrictly: true,
                                    expandTrigger: 'hover',
                                    emitPath: false,
                                    value: 'value',
                                    label: 'label'
                                }" @change="handleTeamTypeChange" placeholder="请选择团队类型" clearable
                                    class="custom-cascader">
                                </el-cascader>
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <!-- 处理类型 -->
                            <!-- <div class="section-title">
                                <i class="el-icon-warning"></i>
                                投诉处理
                            </div> -->
                            <el-form-item label="处理类型" prop="handleType">
                                <template slot="label">
                                    <i class="el-icon-warning"></i>
                                    投诉处理
                                </template>
                                <el-cascader v-model="formData.handleValue" :options="tslxList" :props="{
                                    checkStrictly: true,
                                    expandTrigger: 'hover',
                                    emitPath: false
                                }" @change="handleTypeChange" placeholder="请选择处理类型" clearable class="custom-cascader">
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                    </div>

                </el-row>



                <!-- 对账凭证分类 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-document"></i>
                        <span>凭证列表</span>
                        <el-button type="primary" size="small" icon="el-icon-plus" class="add-evidence-btn"
                            @click="handleAddEvidence">
                            新增凭证
                        </el-button>
                        <el-button type="primary" size="small" icon="el-icon-plus" class="add-evidence-btn"
                            @click="handleAddQwsp">
                            新增企微审批
                        </el-button>
                    </div>

                    <el-tabs v-model="formData.logisticsType" type="card" @tab-click="handlePZTabChange">
                        <el-tab-pane v-for="item in pztypeList" :key="item.itemValue" :label="item.itemLabel"
                            :name="item.itemValue">
                            <div class="evidence-content" v-if="item.itemValue === '1502000'"><!--收款凭证-->
                                <!--收款凭证记录-->
                                <el-table :data="pzList" style="width: 100%" border header-align="center"
                                    cell-class-name="table-cell-center">
                                    <el-table-column prop="amount" label="收款金额" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="account" label="收款账户" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="transaction_no" label="交易单号" min-width="200" align="center">
                                    </el-table-column>
                                    <el-table-column prop="pay_time" label="收款时间" min-width="200" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRegDateTime(scope.row.pay_time) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="file_urls" label="凭证文件" min-width="250" align="center">
                                        <template slot-scope="scope">
                                            <div class="file-links">
                                                <template v-if="scope.row.file_urls">
                                                    <!-- 修改这里，先把字符串分割成数组 -->
                                                    <div v-for="(file, index) in scope.row.file_urls.split(';').filter(Boolean)" 
                                                      :key="index" 
                                                      class="file-item"
                                                    >
                                                      <i class="el-icon-document" />
                                                      <el-button 
                                                        type="text" 
                                                        @click="handleFileDownload(file)"
                                                        class="file-link"
                                                      >
                                                        {{ file.split('/').pop() }}  <!-- 只显示文件名 -->
                                                      </el-button>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="pzType" label="收款用途" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="pzType" label="操作时间" min-width="150" align="center">
                                    </el-table-column> -->
                                    <el-table-column label="操作" min-width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleEditEvidence(scope.row)">编辑</el-button>
                                            <el-button type="text"
                                                @click="handleDeleteReceipt(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="evidence-content" v-else-if="item.itemValue === '1503000'"><!--付款凭证-->
                                <!--付款凭证记录-->
                                <el-table :data="pzList" style="width: 100%" border header-align="center"
                                    cell-class-name="table-cell-center">
                                    <el-table-column prop="amount" label="支付金额" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="account" label="支付账户" min-width="150" align="center">
                                    </el-table-column>
                                    <!-- <el-table-column prop="paymentPurpose" label="付款用途" min-width="150" align="center">
                                    </el-table-column> -->
                                    <el-table-column prop="transaction_no" label="交易订单号" min-width="200" align="center">
                                    </el-table-column>
                                    <el-table-column prop="paymentTime" label="支付时间" min-width="200" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRegDateTime(scope.row.pay_time) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="file_urls" label="凭证文件" min-width="250" align="center">
                                        <template slot-scope="scope">
                                            <div class="file-links">
                                                <template v-if="scope.row.file_urls">
                                                    <!-- 修改这里，先把字符串分割成数组 -->
                                                    <div v-for="(file, index) in scope.row.file_urls.split(';').filter(Boolean)" 
                                                      :key="index" 
                                                      class="file-item"
                                                    >
                                                      <i class="el-icon-document" />
                                                      <el-button 
                                                        type="text" 
                                                        @click="handleFileDownload(file)"
                                                        class="file-link"
                                                      >
                                                        {{ file.split('/').pop() }}  <!-- 只显示文件名 -->
                                                      </el-button>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" min-width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleEditEvidence(scope.row)">编辑</el-button>
                                            <el-button type="text"
                                                @click="handleDeleteReceipt(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- 其他所有凭证 -->
                            <div class="evidence-content" v-else>
                                <el-table :data="pzList" style="width: 100%" border header-align="center"
                                    cell-class-name="table-cell-center">
                                    <!-- <el-table-column prop="created_at" label="上传人" min-width="150" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.created_by }}
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column prop="created_at" label="上传时间" min-width="150" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRegDateTime(scope.row.created_at) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="created_at" label="凭证说明" min-width="200" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.description }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="file_urls" label="凭证文件" min-width="250" align="center">
                                        <template slot-scope="scope">
                                            <div class="file-links">
                                                <template v-if="scope.row.file_urls">
                                                    <!-- 修改这里，先把字符串分割成数组 -->
                                                    <div v-for="(file, index) in scope.row.file_urls.split(';').filter(Boolean)" 
                                                      :key="index" 
                                                      class="file-item"
                                                    >
                                                      <i class="el-icon-document" />
                                                      <el-button 
                                                        type="text" 
                                                        @click="handleFileDownload(file)"
                                                        class="file-link"
                                                      >
                                                        {{ file.split('/').pop() }}  <!-- 只显示文件名 -->
                                                      </el-button>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="操作" min-width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleEditEvidence(scope.row)">编辑</el-button>
                                            <el-button type="text" @click="handleDeleteReceipt(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-tab-pane>

                        <!-- 新增企微审批标签页 -->
                        <el-tab-pane label="企微审批" name="qwsp">
                            <div class="evidence-content">
                                <el-table :data="getQwspRecords" style="width: 100%" border header-align="center"
                                    cell-class-name="table-cell-center">
                                    <el-table-column prop="sp_no" label="审批编号" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="sp_name" label="审批名称" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="amount" label="审批金额" min-width="150" align="center"></el-table-column>
                                    <el-table-column prop="sp_status" label="审批状态" min-width="150" align="center">
                                    </el-table-column>
                                    <el-table-column prop="apply_name" label="当前审批人" min-width="150"
                                        align="center">
                                    </el-table-column>
                                    <el-table-column prop="apply_time" label="审批时间" min-width="150" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRegDateTime(scope.row.apply_time) }}
                                        </template>
                                    </el-table-column>
                                   
                                    <el-table-column label="操作" min-width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="handleDeleteQwsp(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>

                <!-- 物流信息部分 -->
                <div class="form-section">
                    <div class="section-title">
                        <i class="el-icon-truck"></i>
                        <span>物流信息</span>
                        <el-button type="primary" size="small" icon="el-icon-plus" class="add-logistics-btn"
                            @click="handleAddLogistics">
                            新增物流信息
                        </el-button>
                    </div>

                    <!-- 物流信息表格 -->
                    <el-table :data="logisticsRecords" style="width: 100%" border header-align="center"
                        cell-class-name="table-cell-center">
                        <el-table-column prop="logistics_type_name" label="物流类型" min-width="150" align="center">
                        </el-table-column>
                        <el-table-column prop="express_company_name" label="物流公司" min-width="200" align="center">
                        </el-table-column>
                        <el-table-column prop="tracking_no" label="物流单号" min-width="200" align="center">
                        </el-table-column>
                        <el-table-column prop="customer_name" label="客户姓名" min-width="150" align="center">
                        </el-table-column>
                        <el-table-column prop="customer_phone" label="客户电话" min-width="150" align="center">
                        </el-table-column>
                        <el-table-column prop="customer_address" label="客户地址" min-width="150" align="center">
                        </el-table-column>
                        <el-table-column prop="status_name" label="物流状态" min-width="150" align="center">
                        </el-table-column>
                        <el-table-column label="操作" min-width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="handleEditLogistics(scope.row)">编辑</el-button>
                                <el-button type="text" @click="handleDeleteLogistics(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 工单状态 -->
                <div class="form-section">
                    <el-row :gutter="8" type="flex" align="middle">
                        <el-col :span="5">
                            <el-form-item label="工单状态" prop="ticketStatus" required>
                                <template slot="label">
                                    <i class="el-icon-s-order"></i>
                                    工单状态
                                </template>
                                <el-radio-group v-model="formData.ticketStatus">
                                    <el-radio v-for="item in ticketStatusList" :key="item.itemValue" :label="item.itemValue">
                                        {{ item.itemLabel }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="备注" style="margin-left: 8px; width: 500px;">
                                <template slot="label" prop="Remark">
                                    <i class="el-icon-edit-outline"></i>
                                    备注：
                                </template>
                                <el-input 
                                    v-model="formData.Remark" 
                                    placeholder="请输入备注" 
                                    style="width: 300px;"
                                    size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 提交按钮 -->
                <div class="form-actions">
                    <el-button 
                        type="primary" 
                        @click="submitForm('complaintForm')"
                        :loading="loading"
                        :disabled="loading"
                    >
                        {{ loading ? '提交中...' : '提交工单' }}
                    </el-button>
                    <el-button @click="resetForm('complaintForm')">新增</el-button>
                </div>
            </el-form>
        </div>

        <!-- 新增凭证弹窗 -->
        <el-dialog title="新增凭证" :visible.sync="pzDialogVisible" width="600px">
            <el-form :model="pzFormData" ref="pzFormData" label-width="120px">
                <!-- 凭证类型选择 -->
                <el-form-item label="凭证类型" prop="type" required>
                    <el-select v-model="pzFormData.type" placeholder="请选择凭证类型" style="width: 100%"
                        @change="handlePzTypeChange">
                        <el-option v-for="item in pztypeList" :key="item.itemValue" :label="item.itemLabel"
                            :value="item.itemValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 收款凭证 -->
                <template v-if="pzFormData.type === '1502000'">
                    <el-form-item label="收款金额" required>
                        <el-input v-model="pzFormData.receiptAmount" type="number" placeholder="请输入收款金额">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="收款账户" required>
                        <el-input v-model="pzFormData.receiptAccount" placeholder="请输入收款账户"></el-input>
                    </el-form-item>
                    <el-form-item label="交易单号" required>
                        <el-input v-model="pzFormData.orderNo" placeholder="请输入交易单号"></el-input>
                    </el-form-item>
                    <el-form-item label="收款时间" required>
                        <el-date-picker v-model="pzFormData.receiptTime" type="datetime" placeholder="选择收款时间"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="new Date()" style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                </template>

                <!-- 付款凭证 -->
                <template v-else-if="pzFormData.type === '1503000'">
                    <el-form-item label="支付金额" required>
                        <el-input v-model="pzFormData.paymentAmount" type="number" placeholder="请输入支付金额">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>



                    <el-form-item label="支付账户" required>
                        <el-input v-model="pzFormData.paymentAccount" placeholder="请输入支付账户"></el-input>
                    </el-form-item>
                    <el-form-item label="交易订单号" required>
                        <el-input v-model="pzFormData.paymentOrderNo" placeholder="请输入交易订单号"></el-input>
                    </el-form-item>
                    <el-form-item label="支付时间" required>
                        <el-date-picker v-model="pzFormData.paymentTime" type="datetime" placeholder="选择支付时间"
                            style="width: 100%">
                        </el-date-picker>
                    </el-form-item>
                </template>
                <!-- 其他凭证 -->

                <!-- 根据选择的凭证类型显示对应的表单内容 -->
                <template class="pz-content">
                    <!-- 设备故障凭证 -->
                    <template>
                        <el-form-item label="备注信息" required>
                            <el-input type="textarea" v-model="pzFormData.remark" rows="3"
                                placeholder="请输入备注信息"></el-input>
                        </el-form-item>
                    </template>

                    <!-- 修改上传区域 -->
                    <div class="upload-drop-zone" >
                        <el-upload ref="upload" class="upload-evidence" 
                        :action="uploadUrl"
                        :http-request="handlePzUpload"
                         :before-upload="beforeEvidenceUpload"
                        :on-preview="handlePreview" 
                        :on-success="handlePzUploadSuccess"
                        :on-remove="handlePzRemove"
                        :file-list="pzFormData.files" list-type="picture-card"
                         :limit="5" multiple
                        :drag="true"
                       :auto-upload="true">
                          <i class="el-icon-plus"></i>
                            
                        </el-upload>
                        
                    </div>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pzDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmitPz">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 新增物流信息弹窗 -->
        <el-dialog title="编辑物流信息" :visible.sync="logisticsDialogVisible" width="600px">


            <el-form :model="logisticsForm" ref="logisticsForm" label-width="120px" :rules="logisticsRules">


                <!-- 发货方信息 -->
                <div class="dialog-section">

                    <div class="section-subtitle">客户信息</div>
                    <el-form-item label="客户姓名" prop="userName" required>
                        <el-autocomplete v-model="logisticsForm.userName" :fetch-suggestions="queryContactSearch"
                            placeholder="请输入客户姓名" @select="handleContactSelect" style="width: 100%">
                            <template slot-scope="{ item }">
                                <div class="suggestion-item">
                                    {{ item.value }}
                                </div>
                            </template>
                        </el-autocomplete>
                    </el-form-item>
                    <el-form-item label="客户电话" prop="userPhone" required>
                        <el-input v-model="logisticsForm.userPhone" placeholder="请输入客户联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="客户地址" prop="userAddress" required>
                        <el-input type="textarea" v-model="logisticsForm.userAddress" :rows="2"
                            placeholder="请输入客户地址"></el-input>
                    </el-form-item>
                </div>




                <div class="dialog-section">
                    <div class="section-subtitle">物流信息</div>
                    <el-form-item label="物流类型" prop="logisticsTypeCode" required>
                        <el-select v-model="logisticsForm.logisticsTypeCode" placeholder="请选择物流类型" style="width: 100%">
                            <el-option v-for="item in wllxList" :key="item.itemValue" :label="item.itemLabel"
                                :value="item.itemValue"></el-option>
                            <!-- <el-option label="发货物流" value="shipping"></el-option>
                    <el-option label="收货物流" value="receiving"></el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流公司" prop="logisticsCompany" required>
                        <!-- <el-input v-model="logisticsForm.logisticsCompany" placeholder="请输入物流公司"></el-input> -->
                        <el-select v-model="logisticsForm.logisticsCompany" placeholder="请选择物流公司" style="width: 100%">
                            <el-option v-for="item in logisticsCompanyList" :key="item.itemValue"
                                :label="item.itemLabel" :value="item.itemValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流单号" prop="logisticsNumber" required>
                        <el-input v-model="logisticsForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
                    </el-form-item>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="logisticsDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitLogisticsForm">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 在表单中添加图片上传部分 -->
        <el-form-item label="退单凭证" prop="returnEvidenceList">
            <el-upload class="upload-demo" action="/api/v1/file/upload" :headers="uploadHeaders"
                :on-preview="handlePreview" :on-remove="handleRemove" :on-success="handleUploadSuccess"
                :before-upload="beforeUpload" :file-list="fileList" multiple :limit="5" list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
            </el-upload>
        </el-form-item>

   

        <!-- 添加企微审批对话框 -->
        <el-dialog title="新增企微审批" :visible.sync="qwspDialogVisible" width="500px">
            <el-form :model="qwspForm" ref="qwspForm" label-width="100px">
                <el-form-item label="企微编号" prop="qwNo" required>
                    <el-input v-model="qwspForm.qwNo" placeholder="请输入企微编号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="qwspDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitQwsp">确 定</el-button>
            </div>
        </el-dialog>
     <!-- 图片预览对话框 -->
     <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

        
        <!-- 添加图片预览对话框 -->
        <!-- <el-dialog
            :visible.sync="previewVisible"
            append-to-body
            width="50%">
            <img width="100%" :src="previewUrl" alt="预览图片">
        </el-dialog> -->
    </div>

</template>

<script>
import request from '@/utils/request' // 确保您有这个请求工具
import { getDictData } from '@/api/dict'
import moment from 'moment'

export default {
    name: 'ComplaintSystem',
    data() {
        return {
            userName: '',
            userPhone: '',
            userAddress: '',
            operationTypeList: [],//操作类型
            getQwspRecords: [],//获取企微审批记录
            ticketStatusList: [],//工单状态
            logisticsList: [],//物流公司
            logisticsRecords: [],//物流记录
            urgencyLevelList: [],//紧急程度
            processResults: [],//处理结果
            teamTypeList: [],
            userTypeList: [],
            sourceChannelList: [],
            tslxList: [],//投诉类型
            pztypeList: [
                {
                    itemValue: '1501000',
                    itemLabel: '设备故障凭证'
                },
                {
                    itemValue: '1502000',
                    itemLabel: '收款凭证'
                },
                {
                    itemValue: '1503000',
                    itemLabel: '付款凭证'
                },
                {
                    itemValue: '1504000',
                    itemLabel: '电话录音'
                },
                {
                    itemValue: '1509000',
                    itemLabel: '其他凭证'
                }
            ],//凭证类型
            companyContactList: [],//公司联系人-收货或者发货
            companyContactListFirstLevel: [],//公司联系人-收货或者发货-一级
            tsjgListFirstLevel: [],//处理结果-一级
            tsjgList: [],//处理结果
            pzDialogVisible: false,
            pzFormData: {
                receipt_no: '',//收款凭证编号
                type: '', // 凭证类型
                // 设备故障凭证字段
                description: '',//凭证描述  

                fileType: '',//凭证类型
                // 收款凭证字段
                receiptAmount: '',//收款金额
                receiptAccount: '',//收款账户
                orderNo: '',//收款订单号
                receiptTime: '',//收款时间  
                remark: '',//收款备注
                // 付款凭证字段
                paymentAmount: '',//付款金额
                paymentAccount: '',//付款账户

                paymentOrderNo: '',//付款订单号
                paymentTime: '',
                // 电话录音字段
                callDescription: '',//录音描述  
                callTime: '',//录音时间
                duration: '',//录音时长
                // 其他凭证字段
                otherDescription: '',//其他凭证描述
                otherFileType: '',//其他凭证类型
                // 文件列表
                files: []//文件列表
            },
            pzList: [],
            formData: {
                handleValue: '1401000',//投诉处理类型
                forwardTime: '',//转单时间
                complaintTime: new Date().toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }).replace(/\//g, '-'),  // 将日期格式中的斜杠替换为横杠
                reactivatedContent: '',
                explanationContent: '',
                sourceChannel: '',//投诉来源
                urgencyLevel: '',//级别编码
                issueTime: '',//问题发生时间
                iccid: '',//用户ICCID
                simCardType: '',//卡类型
                cardNumber: '',//卡号
                channelCode: '',//渠道编码
                externalNumber: '',//外部工单号
                callTime: '',//呼叫时间
                phoneNumber: '',//用户投诉电话
                userIccid: '',//用户ICCID
                userChannelCode: '',//用户通道编码
                userType: '',//用户类型
                agentName: '',//代理商名称
                teamType: '',//团队类型
                marketingTeam: '',//营销团队
                description: '',//问题描述
                handleType: '',//处理退款类型
                repurchaseType: '',//退订类型
                refundReason: '',//退订原因
                receiptAmount: '',//收款金额
                receiptAccount: '',//收款账户
                receiptOrderNo: '',//收款订单号
                receiptTime: '',//收款时间
                receiptPurpose: '',//收款用途
                paymentAmount: '',//付款金额
                paymentPurpose: '',//付款用途
                paymentAccount: '',//付款账户
                paymentOrderNo: '',//付款订单号
                paymentTime: '',//付款时间
                processStatus: '',//处理状态
                systemOperation: '',//系统操作
                agentAccount: '',//代理账户
                rechargeAmount: '',//充值金额
                packageName: '',//套餐名称
                packageNumber: '',//套餐号码
                approvalNumber: '',//审批单号
                satisfaction: 0,//满意度
                abandonReason: '',//废弃原因
                logisticsType: '',//物流类型
                shippingRecords: [],//发货记录
                receivingRecords: [],//收货记录
                shippingCompany: '',//发货公司
                shippingTrackingNo: '',//发货单号
                shippingTime: '',//发货时间
                shippingRemark: '',//发货备注
                receivingCompany: '',//收货公司
                receivingTrackingNo: '',//收货单号
                receivingTime: '',//收货时间
                receivingRemark: '',
                complaintItem: '1201001',//投诉项目
                ticketStatus: '',//工单状态
                weworkNo: '',//企微编号
                processResult: '',//投诉处理结果
                operationType: '',//操作类型
                returnReason: '',//退单原因
                returnEvidenceList: [],//退单凭证
                dialogImageUrl: '',//图片
                dialogVisible: false,
                paymentRecords: [], // 付款凭证记录
                deviceRecords: [], // 设备故障凭证记录
                otherRecords: [], // 其他凭证记录
                pzgsskzh: [], // 收款凭证中收款账户
                logisticsRecords: [], // 物流记录
                wllxList: [],//物流类型
                workOrderId: '',//工单id
                remark: '',//处理结果备注,
                process_reback_file: null,  // 用于存储上传文件的完整信息

                qwspRecords: [],
                Remark: '',//备注
                processTimeText: '', // 替换原来的 forwardTime
                previewVisible: false,  // 预览对话框显示状态
                previewUrl: '',         // 预览图片的URL
            },
            logisticsCompanyList: [],//物流公司列表
            fileList: [],
            rules: {
                // sourceChannel: [{ required: true, message: '请选择来源渠道', trigger: 'change' }],
                // urgencyLevel: [{ required: true, message: '请选择紧急程度', trigger: 'change' }],
                // issueTime: [{ required: true, message: '请选择问题发生时间', trigger: 'change' }],
                // description: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
                // ticketStatus: [{ required: true, message: '请选择工单状态', trigger: 'change' }],
                // weworkNo: [{ required: true, message: '请输入企微编号', trigger: 'blur' }],
                // processResult: [{ required: true, message: '请选择处理结果', trigger: 'change' }],
                // operationType: [{ required: true, message: '请选择操作类型', trigger: 'change' }],
                // agentAccount: [{ required: true, message: '请输入代理账户', trigger: 'blur' }],
                // rechargeAmount: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
                // packageName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
                // packageNumber: [{ required: true, message: '请输入套餐号码', trigger: 'blur' }],
                // abandonReason: [{ required: true, message: '请输入废弃原因', trigger: 'blur' }]
            },
            showExtraFields: false,
            extraFieldLabel: '',
            extraFieldProp: '',
            extraFieldComponent: null,
            extraFieldProps: {},
            dialogVisible: false,
            dialogTitle: '',
            currentLogistics: {
                company: '',
                trackingNo: '',
                time: '',
                remark: '',
                // 发货人信息
                senderName: '',
                senderPhone: '',
                senderAddress: '',
                // 收货人信息
                receiverName: '',
                receiverPhone: '',
                receiverAddress: ''
            },
            currentType: '',
            currentIndex: -1,
            complaintOptions: [], // 投诉项目选项
            // evidenceForm: {
            //     type: '',
            //     // 收款凭证字段
            //     receiptAccount: '',
            //     receiptAmount: '',
            //     receiptTime: '',
            //     receiptOrderNo: '',
            //     receiptPurpose: '',
            //     // 付款凭证字段
            //     paymentAccount: '',
            //     paymentAmount: '',
            //     paymentTime: '',
            //     paymentPurpose: '',
            //     paymentOrderNo: '',
            //     // 其他凭证字段
            //     fileType: '',
            //     collectTime: '',
            //     description: '',
            // },
            logisticsDialogVisible: false,
            logisticsForm: {
                logisticsType: '',
                senderName: '',
                senderPhone: '',
                senderAddress: '',
                receiverName: '',
                receiverPhone: '',
                receiverAddress: '',
                logisticsCompany: '',
                logisticsNumber: '',
                logisticsTypeCode: '',//物流类型编码
            },
            logisticsRules: {
                // logisticsType: [{ required: true, message: '请选择物流类型', trigger: 'change' }],
                // senderName: [{ required: true, message: '请输入发货人姓名', trigger: 'blur' }],
                // senderPhone: [{ required: true, message: '请输入发货人联系电话', trigger: 'blur' }],
                // senderAddress: [{ required: true, message: '请输入发货地址', trigger: 'blur' }],
                // receiverName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
                // receiverPhone: [{ required: true, message: '请输入收货人联系电话', trigger: 'blur' }],
                // receiverAddress: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
                // logisticsCompany: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
                // logisticsNumber: [{ required: true, message: '请输入物流单号', trigger: 'blur' }]
            },
            uploadHeaders: {
                'Authorization': localStorage.getItem('token') // 添加token到上传请求头
            },
            qwspDialogVisible: false,
            qwspForm: {
                qwNo: '',
                spStatus: '',
                currentApprover: ''
            },
            uploadUrl: '/api/v1/upload/file', // 正确的上传接口地址
            issueTimeOptions: {
                disabledDate: (time) => {
                    // 如果没有创建时间，则不限制
                    if (!this.formData.complaintTime) {
                        return false;
                    }
                    // 将创建时间转换为时间戳进行比较
                    const complaintTimestamp = new Date(this.formData.complaintTime).getTime();
                    return time.getTime() > complaintTimestamp;
                }
            },
            forwardTimeOptions: {
                disabledDate: (time) => {
                    // 如果没有创建时间，则不限制
                    if (!this.formData.complaintTime) {
                        return false;
                    }
                    // 获取创建时间的时间戳
                    const complaintTimestamp = new Date(this.formData.complaintTime).getTime();
                    // 禁用早于创建时间的日期
                    return time.getTime() < complaintTimestamp;
                }
            },
            loading: false, // 添加 loading 状态
        }
    },
    async created() {
        try {
            // 获取凭证类型列表
            this.pztypeList = await this.getDictData('KFPZFL');
            //await  this.loadConfig()
            if (this.pztypeList && this.pztypeList.length > 0) {
                // 设置默认选中第一个
                this.formData.logisticsType = this.pztypeList[0].itemValue;
            }
          
        } catch (error) {
            console.error('获取凭证类型列表失败：', error);
        }

      

    },
    mounted() {
        // 添加日志查看数据
        this.loadConfig()
        const id = this.$route.query.id
        if(id){
            this.getWorkOrderDetail(id)
            this.formData.workOrderId = id
            this.loadLogisticsRecords()
            this.handleDeleteReceipt(row)
           
        }
    },
    methods: {

        handlePzRemove(file, fileList) {
           

           this.fileList = this.fileList.filter(item => item !== file.response.data.filename)

          
        },

        handlePzUploadSuccess(response, file, fileList) {
        

            this.fileList.push(response.data.filename)

     

        },

        //获取客服工单详情
        async getWorkOrderDetail(id) {
            const response = await request({
                url: '/api/v1/kf-work-order/detail',
                method: 'POST',
                data: { "work_order_id": id }
            })
           
            if (response.status === 1) {
               let data = response  .data
               this.formData.workOrderId = data.work_order_id//工单ID
               this.formData.sourceChannel = data.source_no//来源渠道
               this.formData.urgencyLevel = data.level_no//紧急程度
              
               this.formData.complaintTime = data.create_time//创建时间
               this.formData.issueTime = data.problem_occur_time//问题发生时间
               this.formData.forwardTime = data.complete_time//处理转发时间
                
               this.formData.complaintItem = data.complaint_no  //投诉项目
              
                this.formData.phoneNumber = data.complaint_phone//投诉电话
               this.formData.userIccid = data.complaint_iccid//用户ICCID
               this.formData.userChannelCode = data.complaint_channel_no//用户通道编码
               this.formData.description = data.problem_desc//问题描述
                this.formData.userType = data.user_type_no   //用户类型
                this.formData.agentName = data.representative_name//代理商名称
               this.formData.teamType = data.team_type_no//团队类型
                this.formData.handleValue = data.process_type_no//处理类型
                this.formData.ticketStatus = data.status_no //工单状态
                this.formData.Remark = data.result_desc//处理结果
                
                
               
               
               


            }
        },
        formatRegDateTime(dateTimeString) {
           
            try {
                if (!dateTimeString) return ''
                return moment(dateTimeString).format('YYYY-MM-DD HH:mm:ss')
            } catch (error) {
                console.error('日期格式化错误:', error)
                return ''
            }
        },
        //定义一个通用方法，根据类型获取字典数据
        async getDictData(_type) {
            const response = await getDictData(_type)
            if (response.status === 1) {
                return response.data
            }
        },

        //定义加载配置
        async loadConfig() {
            this.sourceChannelList = await this.getDictData('KFTSLY')//来源渠道
            this.complaintOptions = await this.getDictData('KFTSXM')//投诉项目
            this.complaintOptions = this.transformDictData(this.complaintOptions)//转换
            this.userTypeList = await this.getDictData('KFYHLX')//用户类型
            this.teamTypeList = await this.getDictData('KFYXTD')//营销团队
            this.teamTypeList = this.transformDictData(this.teamTypeList)//转换
            this.tslxList = await this.getDictData('KFTSLX')//投诉类型
            this.tslxList = this.transformDictData(this.tslxList)//转换
            // this.pztypeList = await this.getDictData('KFZPLX')//凭证类型
            this.urgencyLevelList = await this.getDictData('KFTSJB')//紧急程度
            this.logisticsCompanyList = await this.getDictData('KFWLGS')//物流公司
            this.ticketStatusList = await this.getDictData('KFGDZT')//工单状态
            // this.processResults = await this.getDictData('KFTSJG')//处理结果
            this.processResults = this.transformDictData(this.processResults)//转换
            this.operationTypeList = await this.getDictData('KFWJLX')//操作类型
            this.operationTypeList = this.transformDictData(this.operationTypeList)//转换
            this.pzgsskzh = await this.getDictData('KFGSZH')//收款凭证中收款账户
            this.pzgsskzh = this.transformDictData(this.pzgsskzh)//转换
            this.companyContactList = await this.getDictData('KFGSFHXX')//公司联系人-收货或者发货
            this.companyContactListFirstLevel = this.transformDictDataFirstLevel(this.companyContactList)//转换
            this.wllxList = await this.getDictData('KFWLLX')//物流类型
            this.tsjgList = await this.getDictData("KFTSJG")//获取所有处理结果
            
            this.tsjgListFirstLevel = this.transformDictDataFirstLevel(this.tsjgList)//转换
        
        },
        // 转换字典数据为一级选择器格式
        transformDictDataFirstLevel(data) {
            return data.filter(item => item.parentId === '0')
        },

        // 转换字典数据为级联选择器格式
        transformDictData(data) {
            // 创建一个 Map 来存储所有节点
            const childrenMap = new Map();

            // 第一次遍历，初始化所有节点
            data.forEach(item => {
                const node = {
                    value: item.itemValue,
                    label: item.itemLabel,
                    children: []
                };
                // 使用 itemId 作为 key，因为 parentId 是引用 itemId
                childrenMap.set(item.itemId, node);
            });

            // 第二次遍历，建立父子关系
            data.forEach(item => {
                // 如果 parentId 不为 0，则建立父子关系
                if (item.parentId && item.parentId !== '0') {
                    const parentNode = childrenMap.get(item.parentId);
                    if (parentNode) {
                        parentNode.children.push(childrenMap.get(item.itemId));
                    }
                }
            });

            // 返回顶级节点（parentId 为 0 的节点）
            return data
                .filter(item => !item.parentId || item.parentId === '0')
                .map(item => childrenMap.get(item.itemId));
        },
        //提交工单
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    // 显示加载进度条
                    const loading = this.$loading({
                        lock: true,
                        text: '正在保存工单...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    
                    // 构建请求参数
                    const params = {
                        work_order_id: this.formData.workOrderId, // 新增时为空
                        source_id: this.formData.sourceChannel, // 来源渠道
                        level_no: this.formData.urgencyLevel, // 紧急程度
                        status_no: this.formData.ticketStatus,//工单状态
                        create_at: this.formatDateTime(this.formData.complaintTime), // 格式化创建时间
                        problem_time: this.formatDateTime(this.formData.issueTime), // 格式化问题发生时间
                        trans_time: this.formData.forwardTime, // 转发时间
                        complaint_no: this.formData.complaintItem, // 投诉项目
                        complaint_phone: this.formData.phoneNumber, // 投诉电话
                        complaint_iccid: this.formData.userIccid, // ICCID
                        complaint_channel_no: this.formData.userChannelCode, // 通道编码
                        user_type_no: this.formData.userType, // 用户类型
                        agent_name: this.formData.agentName, // 代理商名称
                        team_type_no: this.formData.teamType, // 团队类型
                        problem_desc: this.formData.description, // 问题描述
                       

                        process_type_no: this.formData.handleValue, // 处理类型
                        result_desc: this.formData.Remark,//处理结果
                        //process_type_property:  this.formData.returnEvidenceList.join(','), // 将图片URL数组转换为逗号分隔的字符串, // 处理类型属性
                        // process_type_note: this.formData.handleType, 

                    }

                   
                    try {
                        // 调用保存接口
                        const res = await request({
                            url: '/api/v1/kf-work-order/save',
                            method: 'POST',
                            data: params
                        });

                        if (res.status === 1) {
                            this.$message.success('工单保存成功')
                            this.formData.workOrderId = res.workOrderId
                           
                            // 保存成功后的处理,如跳转页面等
                            //this.$router.push('/work-order/list')
                        } else {
                            this.$message.error(res.message || '保存失败')
                        }
                    } catch (err) {
                        console.error('保存工单出错:', err)
                        this.$message.error('保存失败,请稍后重试')
                    } finally {
                        // 关闭进度条
                        loading.close();
                    }
                } else {
                    //this.$message.error('请填写完整所有必填项')
                    return false
                }
            })
        },
        resetForm(formName) {
            // 重置表单字段
            this.$refs[formName].resetFields()
            
            // 清空工单编号
            this.formData.workOrderId = ''
            
            // 清空凭证列表
            this.pzList = []
            
            // 清空物流记录
            this.logisticsRecords = []
            
            // 清空企微审批记录
            this.getQwspRecords = []
            
            // 重置创建时间为当前时间
            this.formData.complaintTime = new Date().toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(/\//g, '-')
            
            // 如果有来源渠道，重新设置紧急程度
            if (this.formData.sourceChannel) {
                this.setUrgencyLevel(this.formData.sourceChannel)
            }
        },
      //处理预览图片关闭
      handlePreviewClose() {
        this.previewVisible = false;
       
      },



        handleTypeChange(value) {
            // 根据选择显示不同的额外字段
            const [type, subType] = value;
            this.showExtraFields = true;
            //清空相关字段
            this.formData.iccid = '';
            this.formData.simCardType = '';
            this.formData.cardNumber = '';
            this.formData.channelCode = '';

            switch (subType) {
                case 'refundReason':
                    this.extraFieldLabel = '退款原因';
                    this.extraFieldProp = 'refundReason';
                    this.extraFieldComponent = 'el-input';
                    this.extraFieldProps = {
                        type: 'textarea',
                        rows: 3,
                        placeholder: '请输入退款原因'
                    };
                    break;
                case 'returnEvidence':
                    this.extraFieldLabel = '上传凭证';
                    this.extraFieldProp = 'evidence';
                    this.extraFieldComponent = 'el-upload';
                    this.extraFieldProps = {
                        action: 'https://your-upload-url',
                        multiple: true,
                        limit: 3,
                        'file-list': this.fileList,
                        'on-preview': this.handlePreview,
                        'on-remove': this.handleRemove,
                        'before-remove': this.beforeRemove
                    };
                    break;
                default:
                    this.showExtraFields = false;
            }
        },
        handleRemove(file, fileList) {
           
        },
        handlePreview(file) {
           
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        uploadReceipt() {
          
        },
        uploadPayment() {
            
        },
        handleStatusChange(value) {
            // 切换状态时重置相关字段
            if (value === 'submitted') {
                this.formData.satisfaction = 0;
                this.formData.systemOperation = '';
                this.formData.abandonReason = '';
            } else if (value === 'resolved') {
                this.formData.approvalNumber = '';
                this.formData.abandonReason = '';
            } else if (value === 'processing') {
                this.formData.satisfaction = 0;
                this.formData.systemOperation = '';
                this.formData.abandonReason = '';
            } else if (value === 'abandoned') {
                this.formData.satisfaction = 0;
                this.formData.systemOperation = '';
                this.formData.approvalNumber = '';
            }
        },
       



        handleOperationChange() {
            this.resetOperationFields();
        },
        resetOperationFields() {
            this.formData.agentAccount = '';
            this.formData.rechargeAmount = '';
            this.formData.packageName = '';
            this.formData.packageNumber = '';
        },
        handleDepartmentApproval() {
            if (!this.formData.weworkNo) {
                this.$message.warning('请先输入企微编号');
                return;
            }
            // 处理部门审请逻辑
            this.$message.success('提交部门审请成功');
        },
        // 查询物流信息
        queryLogistics(type, record) {
            if (!record.trackingNo || !record.company) {
                this.$message.warning('请填写完整的物流信息');
                return;
            }

            // console.log(`查询${type}物流信息`, {
            //     company: record.company,
            //     trackingNo: record.trackingNo
            // });
            this.$message.success('物流查询功能开发中...');
        },
        // 格式化日期
        formatDate(date) {
            if (!date) return '';
            return new Date(date).toLocaleString();
        },
        // 添加物流记录
        addLogistics(type) {
            this.currentType = type;
            this.currentIndex = -1;
            this.dialogTitle = '物流记录';
            this.currentLogistics = {
                company: '',
                trackingNo: '',
                time: '',
                remark: '',
                // 发货人信息
                senderName: '',
                senderPhone: '',
                senderAddress: '',
                // 收货人信息
                receiverName: '',
                receiverPhone: '',
                receiverAddress: ''
            };
            this.dialogVisible = true;
        },
        // 编辑物流记录
        editLogistics(type, index) {
            this.currentType = type;
            this.currentIndex = index;
            this.dialogTitle = type === 'shipping' ? '编辑发货记录' : '编辑收货记录';
            const record = type === 'shipping'
                ? this.formData.shippingRecords[index]
                : this.formData.receivingRecords[index];
            this.currentLogistics = JSON.parse(JSON.stringify(record));
            this.dialogVisible = true;
        },

          //删除客服工单凭证
          async handleDeleteReceipt(row) {
            try {
                await this.$confirm('确认删除该凭证记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const res = await request({
                    url: '/api/v1/kf-work-order/receipt/delete',
                    method: 'POST',
                    data: {
                        "receipt_no": row.receipt_no
                    }
                }).then((res) => {
                    if (res.status === 1) {
                        this.$message.success('删除成功');
                        this.getReceiptList(this.formData.workOrderId, this.pzFormData.type);
                    } else {
                        this.$message.error(res.message || '删除失败');
                    }
                })
            } catch (error) {
                console.error('删除凭证出错:', error);
                this.$message.error('删除失败，请稍后重试');
            }
        },
        // 删除物流记录
        async handleDeleteLogistics(row) {
            try {
                await this.$confirm('确认删除该物流记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const res = await request({
                    url: '/api/v1/kf-work-order/logistics/delete',
                    method: 'POST',
                    data: {
                        id: row.id
                    }
                }).then((res) => {                      
                    if (res.status === 1) {
                        this.$message.success('删除成功');
                        //刷新物流记录
                        this.loadLogisticsRecords();
                        
                    } else {
                        this.$message.error(res.message || '删除失败');
                    }
                })
            } catch (error) {
                console.error('删除物流记录出错:', error);
                this.$message.error('删除失败，请稍后重试');
            }
        },
        
        // 保存物流记录
        saveLogistics() {
            if (!this.currentLogistics.company || !this.currentLogistics.trackingNo || !this.currentLogistics.time) {
                this.$message.warning('请填写完整信息');
                return;
            }

            const records = this.currentType === 'shipping'
                ? this.formData.shippingRecords
                : this.formData.receivingRecords;

            if (this.currentIndex === -1) {
                // 新增
                records.push({ ...this.currentLogistics });
            } else {
                // 编辑
                records.splice(this.currentIndex, 1, { ...this.currentLogistics });
            }

            this.dialogVisible = false;
            this.$message.success('保存成功');
        },
        handleComplaintChange(value) {
            // 清空相关字段
            this.formData.iccid = '';
            this.formData.simCardType = '';
            this.formData.cardNumber = '';
            this.formData.channelCode = '';
            this.formData.externalNumber = '';
            this.formData.callTime = '';
        },
        handleTeamTypeChange(value) {
            // 清空相关字段
            this.formData.iccid = '';
            this.formData.simCardType = '';
            this.formData.cardNumber = '';
            this.formData.channelCode = '';
        },
        // 处理工单状态变化
        handleTicketStatusChange(value) {
            // console.log('选择的工单状态：', value); // 添加日志查看状态值
            // 重置相关字段
            this.formData.weworkNo = '';
            this.formData.processResult = '';
            this.formData.operationType = '';
            this.formData.agentAccount = '';
            this.formData.rechargeAmount = '';
            this.formData.packageName = '';
            this.formData.packageNumber = '';
            this.formData.abandonReason = '';
        },
        // 处理处理结果变化
        handleProcessResultChange(value) {
            // 重置操作相关字段
            this.formData.operationType = '';
            this.formData.agentAccount = '';
            this.formData.rechargeAmount = '';
            this.formData.packageName = '';
            this.formData.packageNumber = '';
            this.formData.abandonReason = '';

            // console.log("选择的处理结果:", value)
            //根据value值在tsjgListFirstLevel中找到对应的item
            const item = this.tsjgListFirstLevel.find(item => item.itemValue === value)
            // console.log("找到的item:", item)
            if (item) {
                //根据item的itemId值在tsjgList中找到对应的item
                // 获取所有子节点
                // console.log("所有节点:", this.tsjgList)
                const children = this.tsjgList.filter(item1 => item1.parentId === item.itemId);
                // console.log("所有的子节点:", children);
                this.operationTypeList = children;

            }


        },
        // 处理操作类型变化
        handleOperationTypeChange(value) {
            // 重置具体操作字段
            this.formData.agentAccount = '';
            this.formData.rechargeAmount = '';
            this.formData.packageName = '';
            this.formData.packageNumber = '';
        },
        // 上传前验证
        beforeEvidenceUpload(file) {
            // const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
            const isLt10M = file.size / 1024 / 1024 < 100

            // if (!isImage) {
            //     this.$message.error('只能上传 JPG 或 PNG 格式的图片!')
            //     return false
            // }
            if (!isLt10M) {
                this.$message.error('图片大小不能超过 100MB!')
                return false
            }
            return true
        },
        // 处理退货凭证上传
        async handleReturnEvidenceUpload({ file }) {
            try {
                const formData = new FormData()
                formData.append('file', file)  // key必须为'file'

                // 调用上传API
                const response = await request({
                    url: '/api/v1/upload/file',  // 使用API文档中的地址
                    method: 'POST',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': localStorage.getItem('token')  // 添加token认证
                    }
                })

             

                // 根据API返回格式处理响应
                if (response.data && response.data.status === 1) {
                    this.$message.success('上传成功')

                    // 将文件信息添加到显示列表
                    const fileInfo = {
                        name: response.data.data.fileName,
                        url: response.data.data.url
                    }

                    // 确保returnEvidenceList是数组
                    if (!this.formData.returnEvidenceList) {
                        this.$set(this.formData, 'returnEvidenceList', [])
                    }

                    this.formData.returnEvidenceList.push(fileInfo)

                    // 保存完整的文件信息到process_reback_file
                    this.formData.process_reback_file = response.data.data

                    return fileInfo
                } else {
                    this.$message.error(response.data.message || '上传失败')
                    return false
                }
            } catch (error) {
                console.error('上传错误详情：', error)
                this.$message.error('上传失败，请重试')
                return false
            }
        },
        // 处理图片预览
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 处理移除图片
        handleRemove(file, fileList) {
            this.returnEvidenceList = fileList
        },
        // 处理收款凭证上传
        async handleReceiptUpload({ file }) {
            try {
                const formData = new FormData()
                formData.append('file', file)

                const response = await request({
                    url: '/api/v1/upload',
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })

                if (response.code === 200) {
                    this.$message.success('收款凭证上传成功')
                    // 保存上传后的文件信息
                    this.formData.receiptEvidence = response.data.url
                } else {
                    this.$message.error('上传失败')
                }
            } catch (error) {
                console.error('上传错误:', error)
                this.$message.error('上传失败')
            }
        },
        // 处理付款凭证上传
        async handlePaymentUpload({ file }) {
            try {
                const formData = new FormData()
                formData.append('file', file)

                const response = await request({
                    url: '/api/v1/upload',
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })

                if (response.code === 200) {
                    this.$message.success('付款凭证上传成功')
                    // 保存上传后的文件信息
                    this.formData.paymentEvidence = response.data.url
                } else {
                    this.$message.error('上传失败')
                }
            } catch (error) {
                console.error('上传错误:', error)
                this.$message.error('上传失败')
            }
        },
        // 处理凭证上传
        handleEvidenceUpload(params) {
          
            // 实现上传逻辑
        },
        handleAddEvidence() {
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加凭证');
                return;
            }
            this.pzDialogVisible = true;
            this.pzList = []
            this.dialogImageUrl = ''
            this.fileList = []
        },
        // 删除付款记录
        handleDeletePayment(row) {
            this.$confirm('确认删除该付款记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 这里添加删除逻辑
                const index = this.formData.paymentRecords.indexOf(row);
                if (index > -1) {
                    this.formData.paymentRecords.splice(index, 1);
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 处理设备凭证上传
        handleUploadDevice(row) {
            // 实现上传逻辑
          
        },
        // 删除设备凭证记录
        handleDeleteDevice(row) {
            this.$confirm('确认删除该设备凭证记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const index = this.formData.deviceRecords.indexOf(row);
                if (index > -1) {
                    this.formData.deviceRecords.splice(index, 1);
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 处理其他凭证上传
        handleUploadOther(row) {
            // 实现上传逻辑
            
        },
        // 删除其他凭证记录
        handleDeleteOther(row) {
            this.$confirm('确认删除该凭证记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const index = this.formData.otherRecords.indexOf(row);
                if (index > -1) {
                    this.formData.otherRecords.splice(index, 1);
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 新增物流信息
        handleAddLogistics() {
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加物流信息');
                return;
            }
            this.logisticsDialogVisible = true;
            // 重置表单数据
            this.$nextTick(() => {
                if (this.$refs.logisticsForm) {
                    this.$refs.logisticsForm.resetFields();
                }
                this.logisticsForm = {
                    logisticsType: '', // 设置默认值为发货物流
                    senderName: '',
                    senderPhone: '',
                    senderAddress: '',
                    receiverName: '',
                    receiverPhone: '',
                    receiverAddress: '',
                    logisticsCompany: '',
                    logisticsNumber: ''
                };
            });
        },
        //加载工单物流记录
        loadLogisticsRecords() {
            this.logisticsRecords = []
            request({
                url: '/api/v1/kf-work-order/logistics/list',
                method: 'POST',
                data: { work_order_id: this.formData.workOrderId }
            }).then(res => {
                if (res.status === 1) {
                    this.logisticsRecords = res.data.list
                } else {
                    this.$message.error(res.message || '获取物流信息失败')
                }
            }).catch(err => {
                this.$message.error('获取物流信息出错,请稍后重试')
            })
        },

       
      
        // 提交物流信息表单
        submitLogisticsForm() {
            // 先检查工单ID是否存在
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加物流信息');
                return;
            }

            this.$refs.logisticsForm.validate((valid) => {
                if (valid) {
                    // 显示加载进度条
                    const loading = this.$loading({
                        lock: true,
                        text: '正在保存物流信息...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    const newLogistics = {
                        work_order_id: this.formData.workOrderId,
                        logistics_type_no: this.logisticsForm.logisticsTypeCode,
                        customer_name: this.logisticsForm.userName,
                        customer_phone: this.logisticsForm.userPhone,
                        customer_address: this.logisticsForm.userAddress,
                        express_company_no: this.logisticsForm.logisticsCompany,
                        tracking_no: this.logisticsForm.logisticsNumber,
                    };

                    // 调用保存接口
                    request({
                        url: '/api/v1/kf-work-order/logistics/save',
                        method: 'POST',
                        data: newLogistics
                    }).then(res => {
                        if (res.status === 1) {
                            this.$message.success('物流信息保存成功');
                            this.logisticsDialogVisible = false;
                            this.loadLogisticsRecords();
                        } else {
                            this.$message.error(res.message || '保存失败');
                        }
                    }).catch(err => {
                        this.$message.error('保存物流信息出错,请稍后重试');
                    }).finally(() => {
                        // 关闭进度条
                        loading.close();
                    });
                }
            });
        },
        // 搜索联系人
        queryContactSearch(queryString, cb) {
            const results = queryString
                ? this.companyContactListFirstLevel.filter(contact => {
                    return contact.itemLabel.toLowerCase()
                        .indexOf(queryString.toLowerCase()) === 0;
                })
                : this.companyContactListFirstLevel;

            // 返回匹配的结果
            cb(results.map(contact => ({
                value: contact.itemLabel,
                itemId: contact.itemId
            })));
        },

        // 选择联系人后的处理
        handleContactSelect(item) {
            // 获取选中联系人的子节点信息
            const children = this.companyContactList.filter(contact =>
                contact.parentId === item.itemId
            );

            // 遍历子节点，根据类型填充对应信息
            children.forEach(child => {
                console.log('子节点:', child);
                switch (child.itemValue) {
                    case '01': // 联系方式
                        this.logisticsForm.senderPhone = child.itemLabel;
                        break;
                    case '02': // 地址
                        this.logisticsForm.senderAddress = child.itemLabel;
                        break;
                }
            });
        },

        // 重置表单时清空联系人信息
        handleAddLogistics() {
            this.logisticsDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.logisticsForm) {
                    this.$refs.logisticsForm.resetFields();
                }
                this.logisticsForm = {
                    logisticsType: '',
                    senderName: '',
                    senderPhone: '',
                    senderAddress: '',
                    receiverName: '',
                    receiverPhone: '',
                    receiverAddress: '',
                    logisticsCompany: '',
                    logisticsNumber: ''
                };
            });
        },

        // 选择收货人后的处理
        handleReceiverSelect(item) {
            console.log('选中的收货人:', item);
            console.log('公司联系人列表:', this.companyContactList);

            // 获取选中联系人的子节点信息
            const children = this.companyContactList.filter(contact =>
                contact.parentId === item.itemId
            );

            console.log('找到的子节点:', children);

            // 遍历子节点，根据类型填充对应信息
            children.forEach(child => {
                switch (child.itemValue) {
                    case '01': // 联系方式
                        this.logisticsForm.receiverPhone = child.itemLabel;
                        break;
                    case '02': // 地址
                        this.logisticsForm.receiverAddress = child.itemLabel;
                        break;
                }
            });
        },

        // 重置表单时清空所有联系人信息
        handleAddLogistics() {
            this.logisticsDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.logisticsForm) {
                    this.$refs.logisticsForm.resetFields();
                }
                this.logisticsForm = {
                    logisticsType: '',
                    senderName: '',
                    senderPhone: '',
                    senderAddress: '',
                    receiverName: '',
                    receiverPhone: '',
                    receiverAddress: '',
                    logisticsCompany: '',
                    logisticsNumber: ''
                };
            });
        },

        // 打开新增物流信息弹窗
        async handleAddLogistics() {
            // 确保物流类型数据已加载
            if (this.wllxList.length === 0) {
                this.wllxList = await this.getDictData('KFWLLX');
            }

            this.logisticsDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.logisticsForm) {
                    this.$refs.logisticsForm.resetFields();
                }
                this.logisticsForm = {
                    logisticsType: '',
                    senderName: '',
                    senderPhone: '',
                    senderAddress: '',
                    receiverName: '',
                    receiverPhone: '',
                    receiverAddress: '',
                    logisticsCompany: '',
                    logisticsNumber: ''
                };
            });
        },

        // 初始化数据
        async initData() {
            try {
                // ... 其他数据初始化
                this.wllxList = await this.getDictData('KFWLLX'); // 物流类型
                // ... 其他数据初始化
            } catch (error) {
                console.error('初始化数据失败:', error);
                this.$message.error('初始化数据失败，请刷新页面重试');
            }
        },

        // 在组件创建时调用
        created() {
            this.initData();
            // 在组件创建时设置创建时间
            this.formData.complaintTime = new Date().toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(/\//g, '-');
        },
        // 团队类型选择处理函数
        handleTeamTypeChange(value) {
            // value 现在直接是最后一级的值，不再是数组
            console.log('选择的团队类型:', value);
            this.formData.teamType = value;
        },
        handleUploadSuccess(response, file, fileList) {
            if (response.code === 0) {
                this.fileList = fileList;
                // 将上传成功的文件URL添加到表单数据中
                this.formData.returnEvidenceList = fileList.map(file => file.url || '').filter(url => url);
                this.$message.success('上传成功');
            } else {
                this.$message.error('上传失败');
            }
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            return true;
        },
        submitQwsp() {
            // 先检查工单ID是否存在
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加企微审批');
                return;
            }

            this.$refs.qwspForm.validate((valid) => {
                if (valid) {
                    const qwspData = {
                        sp_no: this.qwspForm.qwNo,
                        work_order_id: this.formData.workOrderId
                    };

                    request({
                        url: '/api/v1/kf-work-order/approval/save',
                        method: 'POST',
                        data: qwspData
                    }).then(res => {
                        if (res.status === 1) {
                            this.$message.success('企微审批绑定成功')
                            this.qwspDialogVisible = false;
                            this.fetchQwspRecords()
                        } else {
                            this.$message.error(res.message || '保存失败')
                        }
                    }).catch(err => {

                        this.$message.error('企微审批绑定失败,请稍后重试')
                    })

                    // // 这里应该将企微审批数据添加到 formData 中

                    // this.$message.success('企微审批添加成功');
                }
            });
        },
        // 获取企微审批记录
        fetchQwspRecords() {
            this.getQwspRecords = []
            request({
                url: '/api/v1/kf-work-order/approval/list',
                method: 'post',
                data: {
                    work_order_id: this.formData.workOrderId
                }
            }).then(res => {
                this.getQwspRecords = res.data.list
            }).catch(err => {
                console.error('获取企微审批记录失败:', err);
            })
            console.log('企微审批记录:', this.getQwspRecords)
        },

        //凭证标签页切换
        handlePZTabChange(value) {
            // 清空凭证列表
            this.pzList = []
            
            // this.formData.workOrderId = value
            if (value.name == "qwsp") {
                this.fetchQwspRecords()
            } else {
                this.formData.logisticsType = value.name
                this.pzFormData.type = value.name
                // 清空当前显示的凭证列表
                this.pzList = []
                
                // 获取对应类型的凭证列表
                this.getReceiptList(this.formData.workOrderId, this.formData.logisticsType)
            }
        },
        //删除企微审批记录
        handleDeleteQwsp(row) {
            this.$confirm('确认删除该企微审批记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request({
            url: '/api/v1/kf-work-order/approval/delete',
            method: 'POST',
            data: {
                sp_no: row.sp_no,
                work_order_id: this.formData.workOrderId
            }
           }).then(res => { 
            if(res.status === 1){
                this.$message.success('删除成功')
                this.fetchQwspRecords()
            }else{
                this.$message.error(res.message || '删除失败')

            }
           })
            })
          
        },
        // 打开新增企微审批对话框
        handleAddQwsp() {
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加企微审批');
                return;
            }
            this.qwspDialogVisible = true;
            this.qwspForm = {
                qwNo: '',
                spStatus: '',
                currentApprover: ''
            };
        },
        handlePzTypeChange(value) {
            console.log('value1:', value)
            // 重置表单数据
            this.pzFormData = {
                type: value,
                description: '',
                collector: '',
                fileType: '',
                receiptAmount: '',
                receiptAccount: '',
                orderNo: '',
                // 如果是收款凭证，设置默认时间为当前时间
                receiptTime: value === '1502000' ? this.formatDateTime(new Date()) : '',
                remark: '',
                paymentAmount: '',
                paymentAccount: '',
                paymentPurpose: '',
                paymentOrderNo: '',
                paymentTime: '',
                callDescription: '',
                callTime: '',
                duration: '',
                otherDescription: '',
                otherFileType: '',
                files: []
            };

            // 获取对应类型的凭证列表
            if (this.formData.workOrderId) {
                this.getReceiptList();
            }
        },
        //从后台根据工单编号和凭证类型获取对应的凭证列表
        getReceiptList(workOrderId, receiptTypeNo) {
            this.pzList = [];
            request({
                url: '/api/v1/kf-work-order/receipt/list',
                method: 'POST',
                data: {
                    work_order_id: workOrderId,
                    receipt_type_no: receiptTypeNo
                }
            }).then(res => {
                if (res.status === 1) {
                    // 处理每条记录的文件URL
                    this.pzList = res.data.list.map(item => {
                        // 如果有多个文件URL，只取最后一个（最新的）
                        if (item.file_urls) {
                            const urls = item.file_urls.split(';')
                            item.file_urls = urls[urls.length - 1] // 只保留最后一个URL
                        }
                        return item
                    })
                }
            })
        },

        //凭证保存
        handleSubmitPz() {
            // 先检查工单ID是否存在
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再添加凭证');
                return;
            }

            this.$refs.pzFormData.validate((valid) => {
                if (valid) {
                    // 显示加载进度条
                    const loading = this.$loading({
                        lock: true,
                        text: '正在保存凭证...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 构建请求参数
                    const params = {
                        work_order_id: this.formData.workOrderId,
                        receipt_no: this.pzFormData.receipt_no,  
                        receipt_type_no: this.pzFormData.type,
                        description: this.pzFormData.remark,
                        file_urls: this.fileList.join(';'),
                        //file_urls: this.pzFormData.files.map(file => file.name).join(','),
                       
                    };

                    // 如果是收款/付款凭证，添加额外参数
                    if (this.pzFormData.type === '1502000' || this.pzFormData.type === '1503000') {
                        params.account = this.pzFormData.type === '1502000' ? 
                            this.pzFormData.receiptAccount : this.pzFormData.paymentAccount;
                        params.amount = Number(this.pzFormData.type === '1502000' ? 
                            this.pzFormData.receiptAmount : this.pzFormData.paymentAmount);
                        params.pay_time = moment(this.pzFormData.type === '1502000' ? 
                            this.pzFormData.receiptTime : this.pzFormData.paymentTime).format('YYYY-MM-DD HH:mm:ss');
                        params.order_no = this.pzFormData.type === '1502000' ? 
                            this.pzFormData.orderNo : this.pzFormData.paymentOrderNo;
                        params.transaction_no = params.order_no;
                    }

                    // 调用保存凭证接口
                    request({
                        url: '/api/v1/kf-work-order/receipt/save',
                        method: 'POST',
                        data: params
                    }).then(res => {
                        if (res.status === 1) {
                            this.$message.success('凭证保存成功');
                            this.pzDialogVisible = false;
                            // 重新获取凭证列表
                            this.getReceiptList(this.formData.workOrderId, this.pzFormData.type);
                          
                        } else {
                            this.$message.error(res.message || '保存失败');
                        }
                    }).catch(err => {
                        console.error('保存凭证出错:', err);
                        this.$message.error('保存失败,请稍后重试');
                    }).finally(() => {
                        // 关闭进度条
                        loading.close();
                    });
                } else {
                    this.$message.warning('请填写完整所有必填项');
                    return false;
                }
            });
        },
        // 处理凭证上传
        handlePzUpload({ file }) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);

                request({
                    url: '/api/v1/upload/file',
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.status === 1) {
                        // 只保存新上传的文件
                        this.pzFormData.files = [{  // 替换整个数组而不是追加
                            name: file.name,
                            url: response.data,
                            raw: file
                        }]
                        
                        // 更新文件列表，只保留最新的文件
                        this.fileList = [response.data]

                        this.$message.success('上传成功')
                        resolve(response)
                    } else {
                        reject(new Error(response.message || '上传失败'))
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        handleDragOver(e) {
            console.log('拖拽悬停');
            e.target.classList.add('is-dragover');
        },
        handleDragLeave(e) {
            console.log('拖拽离开');
            e.target.classList.remove('is-dragover');
        },
        async handleDrop(e) {
            e.preventDefault()
            e.target.classList.remove('is-dragover')
            const files = Array.from(e.dataTransfer.files)

            // 清空所有类型的凭证文件列表
            this.pzFormData.files = []
            this.fileList = []
            
            // 清空上传组件
            if (this.$refs.pzUpload) {
                this.$refs.pzUpload.clearFiles()
            }

            // 过滤出支持的文件类型
            const validFiles = files.filter(file => {
                const isValidType = /\.(jpg|jpeg|png|pdf)$/i.test(file.name)
                const isValidSize = file.size <= 10 * 1024 * 1024 // 10MB

                if (!isValidType) {
                    this.$message.error(`文件 ${file.name} 格式不支持`)
                }
                if (!isValidSize) {
                    this.$message.error(`文件 ${file.name} 大小超过10MB`)
                }

                return isValidType && isValidSize
            })

            // 只处理第一个有效文件
            if (validFiles.length > 0) {
                const file = validFiles[0]
                try {
                    await this.handlePzUpload({ file })
                } catch (error) {
                    console.error('文件上传失败:', error)
                    this.$message.error('文件上传失败')
                }
            }
        },
        handleUploadError(error, file) {
            this.$message.error(`文件 ${file.name} 上传失败：${error.message}`);
        },
        // 格式化日期时间
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 初始化表单数据
        initFormData() {
            this.pzFormData = {
                // ... 其他字段
                files: [] // 初始化文件列表为空数组
            };
        },
        // 添加移除文件的方法
        removeFile(file) {
            const fileIndex = this.pzFormData.files.findIndex(f =>
                f.name === file.name && f.raw === file
            );
            if (fileIndex !== -1) {
                this.pzFormData.files.splice(fileIndex, 1);
            }
        },
        // 添加图片预览方法
        handlePreview(file) {
            this.previewUrl = file.url;
            this.previewVisible = true;
        },
        // 修改预览处理方法
        handlePreview(file) {
            console.log('预览文件:', file);
            // 优先使用服务器返回的URL，如果没有则使用本地预览URL
            this.previewUrl = file.response ? file.response.data.url : file.url;
            this.previewVisible = true;
        },
        // 修改上传成功后的处理
        handlePzUpload({ file }) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);

                request({
                    url: '/api/v1/upload/file',
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.status === 1) {
                        const fileIndex = this.pzFormData.files.findIndex(f =>
                            f.name === file.name && f.raw === file
                        );
                        if (fileIndex !== -1) {
                            // 更新文件信息，包括预览URL
                            this.pzFormData.files[fileIndex] = {
                                ...this.pzFormData.files[fileIndex],
                                url: response.data.url,
                                response: response // 保存响应信息
                            };
                            URL.revokeObjectURL(this.pzFormData.files[fileIndex].previewUrl);
                        }
                        this.$message.success('上传成功');
                        resolve(response);
                    } else {
                        reject(new Error(response.message || '上传失败'));
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        watch: {
            // 监听创建时间的变化，如果创建时间小于问题时间，则清空问题时间
            'formData.complaintTime': {
                handler(newVal) {
                    if (this.formData.issueTime && newVal) {
                        const complaintTime = new Date(newVal).getTime();
                        const issueTime = new Date(this.formData.issueTime).getTime();
                        if (issueTime > complaintTime) {
                            this.formData.issueTime = '';
                            this.$message.warning('问题发生时间不能晚于创建时间');
                        }
                    }
                },
                immediate: true
            },
            'formData.complaintTime': {
                handler(newVal) {
                    if (newVal) {
                        const complaintTime = new Date(newVal).getTime();

                        // 检查问题时间
                        if (this.formData.issueTime) {
                            const issueTime = new Date(this.formData.issueTime).getTime();
                            if (issueTime > complaintTime) {
                                this.formData.issueTime = '';
                                this.$message.warning('问题发生时间不能晚于创建时间');
                            }
                        }

                        // 检查转发时间
                        if (this.formData.forwardTime) {
                            const forwardTime = new Date(this.formData.forwardTime).getTime();
                            if (forwardTime < complaintTime) {
                                this.formData.forwardTime = '';
                                this.$message.warning('转发时间必须在创建时间之后');
                            }
                        }
                    }
                },
                immediate: true
            },
            // 监听来源渠道的变化
            'formData.sourceChannel': {
                handler(newValue) {
                    if (!newValue) return;
                    this.setUrgencyLevel(newValue);
                },
                immediate: true
            }
        },


        // 在工单加载完成后调用
        async loadWorkOrder() {
            // ... 其他工单数据加载代码

            // 如果有工单ID，获取凭证列表
            if (this.formData.workOrderId) {
                await this.getReceiptList(this.formData.workOrderId, this.pzFormData.type);
            }
        },
        // 编辑凭证
        handleEditEvidence(row) {
            // 打开新增凭证弹窗
            this.pzDialogVisible = true;
            console.log(row);
            console.log(this.pzFormData);

            // 设置凭证类型
            this.pzFormData.type = row.receipt_type_no;
            this.pzFormData.receipt_no=row.receipt_no;
            //files按照逗号拆分成数组
            this.pzFormData.files = row.file_urls ? row.file_urls.split(',').map(url => ({
                name: url.split('/').pop(),
                url: url
            })) : [];


            // 根据凭证类型填充数据
            switch (row.receipt_type_no) {
                case '1501000': // 设备故障凭证
                    this.pzFormData = {
                        type: row.receipt_type_no,
                        receipt_no: row.receipt_no,
                        remark: row.description,
                        files: row.file_urls ? row.file_urls.split(',').map(url => ({
                            name: url.split('/').pop(),
                            url: url
                        })) : []
                    };
                    break;

                case '1502000': // 收款凭证
                    this.pzFormData = {
                        type: row.receipt_type_no,
                        receipt_no: row.receipt_no,
                        receiptAmount: row.amount,
                        receiptAccount: row.account,
                        orderNo: row.order_no,
                        receiptTime: row.pay_time,
                        remark: row.description,
                        files: row.file_urls ? row.file_urls.split(',').map(url => ({
                            name: url.split('/').pop(),
                            url: url
                        })) : []
                    };
                    break;

                case '1503000': // 付款凭证
                    this.pzFormData = {
                        type: row.receipt_type_no,
                        receipt_no: row.receipt_no,
                        paymentAmount: row.amount,
                        paymentAccount: row.account,
                        paymentOrderNo: row.order_no,
                        paymentTime: row.pay_time,
                        remark: row.description,
                        files: row.file_urls ? row.file_urls.split(',').map(url => ({
                            name: url.split('/').pop(),
                            url: url
                        })) : []
                    };
                    break;
                
            }
        },
        handleFileDownload(fileUrl) {
            console.log('文件URL:', fileUrl);
            // 判断是否是图片文件
            if (/\.(jpg|jpeg|png|gif|bmp)$/i.test(fileUrl)) {
                // 如果是图片，则预览
                this.dialogImageUrl = fileUrl.startsWith('http') ? fileUrl : `/api/api/v1/static/${fileUrl}`;
                this.dialogVisible = true;
            } else {
                // 如果不是图片，则下载
                const downloadUrl = fileUrl.startsWith('http') ? fileUrl : `/api/api/v1/static/${fileUrl}`;
                window.open(downloadUrl, '_blank');
            }
        },
        // 编辑物流信息
        handleEditLogistics(row) {
            // 先检查工单ID是否存在
            if (!this.formData.workOrderId) {
                this.$message.warning('请先保存工单，再编辑物流信息');
                return;
            }
            
            this.logisticsDialogVisible = true;
          
            // 填充表单数据
            this.logisticsForm = {
                logisticsTypeCode: row.logistics_type_no,
                userName: row.customer_name,
                userPhone: row.customer_phone,
                userAddress: row.customer_address,
                logisticsCompany: row.express_company_no,
                logisticsNumber: row.tracking_no
            };
        },
        // 添加设置紧急程度的方法
        setUrgencyLevel(sourceChannel) {
            console.log('===== 开始设置紧急程度 =====');
            console.log('当前来源渠道:', sourceChannel);
            
            let newLevel = '';
            // 低优先级：400(1101000)、公众号(1102000)、代理群(1103000)
            if (['1101000', '1102000', '1103000'].includes(sourceChannel)) {
                newLevel = '3';
                console.log('应设置为低优先级(3)');
            }
            // 中优先级：供应商群(1105000)、运营商群(1107000)、微信群(1109100)
            else if (['1105000', '1107000','1109100'].includes(sourceChannel)) {
                newLevel = '2';
                console.log('应设置为中优先级(2)');
            }
            // 高优先级：监管部门(1106000)、商户(1104000)，钉钉群(1108000)
            else if (['1106000', '1104000', '1108000'].includes(sourceChannel)) {
                newLevel = '1';
                console.log('应设置为高优先级(1)');
            }
            // 中低优先级：电商(1109000)
            else if (['1109000'].includes(sourceChannel)) {
                newLevel = '4';
                console.log('应设置为中低优先级(4)');
            }

            // 使用 $set 更新值
            this.$set(this.formData, 'urgencyLevel', newLevel);
            // 设置处理时效文本
            this.$set(this.formData, 'processTimeText', this.getProcessTimeText(newLevel));
            
         
        },
        // 添加来源渠道变化的处理方法
        handleSourceChannelChange(value) {
           
            this.setUrgencyLevel(value);
        },
        // 获取处理时效文本
        getProcessTimeText(urgencyLevel) {
            switch(urgencyLevel) {
                case '1':
                    return '1小时';
                case '2':
                    return '12小时';
                case '3':
                    return '24小时';
                case '4':
                    return '8小时';
                default:
                    return '请选择紧急程度';
            }
        },

        // 获取提示文本
        getProcessTimeTooltip(urgencyLevel) {
            switch(urgencyLevel) {
                case '1':
                    return '高优先级工单需在1小时内处理完成';
                case '2':
                    return '中优先级工单需在12小时内处理完成';
                case '3':
                    return '低优先级工单需在24小时内处理完成';
                case'4':
                    return '中低优先级工单需在8小时内处理完成';
                default:
                    return '请先选择紧急程度';
            }
        },
        // 添加时间格式化方法
        formatDateTime(dateTime) {
            if (!dateTime) return '';
            return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
        },
        // 新增凭证按钮点击事件
        handleAddPz() {
            // 清空凭证列表
            this.pzList = []
            
            // 清空表单数据
            this.pzFormData = {
                type: '',           // 凭证类型
                receipt_no: '',     // 凭证编号
                remark: '',         // 备注信息
                files: [],          // 文件列表
                
                // 收款凭证字段
                receiptAccount: '', 
                receiptAmount: '',  
                receiptTime: '',    
                orderNo: '',        
                
                // 付款凭证字段
                paymentAccount: '', 
                paymentAmount: '',  
                paymentTime: '',    
                paymentOrderNo: ''  
            }

            // 清空文件列表和上传组件
            this.fileList = []
            if (this.$refs.pzUpload) {
                this.$refs.pzUpload.clearFiles()
            }

            // 重置表单校验状态
            if (this.$refs.pzForm) {
                this.$refs.pzForm.resetFields()
            }

            // 显示新增凭证对话框
            this.pzDialogVisible = true
        },

        // 关闭对话框时也清空数据
        handlePzDialogClose() {
            // 清空表单数据
            this.pzFormData = {
                type: '',
                receipt_no: '',
                remark: '',
                files: [],
                receiptAccount: '',
                receiptAmount: '',
                receiptTime: '',
                orderNo: '',
                paymentAccount: '',
                paymentAmount: '',
                paymentTime: '',
                paymentOrderNo: ''
            }

            // 清空文件列表
            this.fileList = []
            this.pzList = [];
            
            // 清空上传组件
            if (this.$refs.pzUpload) {
                this.$refs.pzUpload.clearFiles()
            }

            // 重置表单校验状态
            if (this.$refs.pzForm) {
                this.$refs.pzForm.resetFields()
            }
        },
        // 修改预览处理方法
        handlePreview(file) {
            // 优先使用文件的 URL
            this.previewUrl = file.url || file.response?.data
            this.previewVisible = true
        },

        // 添加 ICCID 失焦处理方法
        async handleIccidBlur() {
            if (this.formData.userIccid) {
                await this.getIccidInfo(this.formData.userIccid)
            }
        },

        // 添加 ICCID 变化处理方法
        handleIccidChange(value) {
            // 当输入长度达到19位时自动查询
            if (value && value.length === 19) {
                this.getIccidInfo(value)
            }
        },

        // 添加获取 ICCID 信息的方法
        async getIccidInfo(iccid) {
            try {
                const response = await request({
                    url: '/api/v1/kf-work-order/getInfobyIccid',
                    method: 'POST',
                    data: {
                        vcode: iccid
                    }
                })

                if (response.status === 1 && response.data) {
                    // 根据 kind 设置用户类型单选按钮
                    // kind: 1 - 非套餐用户, 2 - 套餐用户
                    this.formData.userType = response.data.kind === 1 ? '1301000' : '1302000'
                    
                    // 设置代理商名称
                    this.formData.agentName = response.data.agent_name || ''

                    // 添加成功提示，显示用户类型和代理商
                    const userTypeText = response.data.kind === 1 ? '非套餐用户' : '套餐用户'
                    // this.$message({
                    //     message: `已自动识别为${userTypeText}，代理商：${response.data.agent_name}`,
                    //     type: 'success',
                    //     duration: 3000
                    // })
                } else {
                    this.$message.warning('未查询到该ICCID信息')
                    
                    // 清空相关字段
                    this.formData.userType = ''
                    this.formData.agentName = ''
                }
            } catch (error) {
                console.error('获取ICCID信息失败:', error)
                this.$message.error('获取ICCID信息失败')
                
                // 发生错误时也清空相关字段
                this.formData.userType = ''
                this.formData.agentName = ''
            }
        },

        // 修改重置表单方法，确保清空这些字段
        resetForm(formName) {
            this.$refs[formName].resetFields()
            this.formData.workOrderId = ''
            this.formData.userType = ''  // 清空用户类型
            this.formData.agentName = '' // 清空代理商名称
            this.pzList = []
            this.logisticsRecords = []
            this.getQwspRecords = []
            
            // 重置创建时间为当前时间
            this.formData.complaintTime = new Date().toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(/\//g, '-')
            
            if (this.formData.sourceChannel) {
                this.setUrgencyLevel(this.formData.sourceChannel)
            }
        }
    },
    created() {
        this.initFormData();
        // 确保配置加载完成
        this.loadConfig().then(() => {
            // 如果有初始来源渠道，设置对应的紧急程度
            if (this.formData.sourceChannel) {
                this.setUrgencyLevel(this.formData.sourceChannel);
            }
        });
    }
}
</script>

<style scoped>
/* 整体容器样式调整 */
.complaint-container {
    padding: 5px;
    /* 减小整体内边距 */
}



/* 表单区域样式调整 */
.form-section {
    background-color: #f5f7fa;
    padding: 8px 15px;
    /* 减小区域内边距 */
    border-radius: 4px;
    margin-bottom: 8px;
    /* 减小区域间距 */
}

/* 区域标题样式调整 */
.section-title {
    font-size: 14px;
    margin-bottom: 10px;
    /* 减小标题底部间距 */
    display: flex;
    align-items: center;
}

/* 表单行样式调整 */
.form-row {
    margin-bottom: 8px;
    /* 减小行间距 */
}

/* 表单项样式调整 */
.el-form-item {
    margin-bottom: 8px;
    /* 减小表单项间距 */
}

/* 最后一个表单项移除底部间距 */
.el-form-item:last-child {
    margin-bottom: 0;
}

/* 调整栅格列间距 */
.el-row {
    margin-left: -10px !important;
    margin-right: -10px !important;
}

.el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
}

/* 时间选择器区域样式调整 */
.time-row {
    padding: 8px 12px;
    margin-bottom: 15px;
}

/* 调整表单项标签和内容的行高 */
.el-form-item__label,
.el-form-item__content {
    line-height: 30px;
    /* 减小行高 */
}

/* 输入框高度调整 */
.el-input__inner {
    height: 32px;
    /* 减小输入框高度 */
    line-height: 32px;
}

/* 单选按钮组样式调整 */
.el-radio-group {
    line-height: 32px;
}

/* 级联选择器样式调整 */
.el-cascader {
    line-height: 32px;
}

/* 文本域样式调整 */
.el-textarea__inner {
    padding: 5px 10px;
}

/* 调整相等高度的区域 */
.equal-height {
    min-height: auto;
    /* 移除最小高度限制 */
}



/* 修改容器样式 */
.complaint-container {
    padding: 10px 30px;
    /* 减小顶部内边距 */
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 修改整体背景样式 */
.complaint-system {
    background: #f0f2f5;
    min-height: 80vh;
    padding: 10px;  /* 减小整体页面的内边距 */
    /* 减小整体内边距 */
}

/* 页面整体字体大小调整 */
.complaint-system {
    font-size: 5px;
    /* 调整基础字体大小 */
}

/* 区块标题样式 */
.section-title {
    font-size: 18px;
    /* 增大区块标题字体 */
    color: #1a5f7a;
    font-weight: 500;
    margin-bottom: 10px;
}

/* 表单项样式调整 */
.el-form-item__label {
    font-size: 13px !important;
    /* 增大表单标签字体 */
}

/* 输入框文字大小 */
.el-input__inner,
.el-textarea__inner {
    font-size: 16px !important;
    /* 增大输入框字体 */
}

/* 下拉选择框文字大小 */
.el-select .el-input__inner {
    font-size: 16px !important;
}

/* 单选按钮文字大小 */
.el-radio__label {
    font-size: 16px !important;
}

/* 级联选择器文字大小 */
.el-cascader__label {
    font-size: 16px !important;
}

/* 表格内容文字大小 */
.el-table {
    font-size: 16px !important;
}

/* 按钮文字大小 */
.el-button {
    font-size: 16px !important;
}

/* 标签页标题文字大小 */
.el-tabs__item {
    font-size: 16px !important;
}

/* 上传组件提示文字 */
.el-upload__tip {
    font-size: 14px !important;
}

/* 修改头部样式 */
.page-header {
    width: 100%;
    height: 90px;
    background: linear-gradient(135deg, #1a5f7a 0%, #2193b0 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    border-radius: 20px;
    box-shadow: 0 8px 30px rgba(33, 147, 176, 0.2);
    position: relative;
   
}

.page-header::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0) 100%);
    transform: rotate(45deg);
    animation: shine 3s infinite;
}

@keyframes shine {
    0% {
        transform: translateX(-100%) rotate(45deg);
    }

    100% {
        transform: translateX(100%) rotate(45deg);
    }
}

.header-content {
    color: #fff;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 3px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
    position: relative;
}

/* 修改标题样式 */
.section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #1a5f7a;
    font-weight: 500;
    padding-left: 12px;
    /* 减小左边框的内边距 */
    border-left: 3px solid #2193b0;
    /* 稍微减小边框宽度 */
}

.section-title i {
    margin-right: 6px;
    /* 减小图标的右边距 */
    font-size: 16px;
    color: #2193b0;
}

.section-title span {
    margin-right: 12px;
    /* 减小标题文字与按钮的间距 */
}

/* 新增凭证按钮样式 */
.add-evidence-btn {
    margin-left: 10px;
    /* 给按钮之间添加间距 */
    padding: 6px 12px;
    font-size: 12px;
    background-color: #2193b0;
    border-color: #2193b0;
    height: 34px;
    line-height: 1;
}

.add-evidence-btn:hover {
    background-color: #1a5f7a;
    border-color: #1a5f7a;
}

.form-actions {
    text-align: center;
    margin-top: 15px;  /* 减小顶部间距 */
    padding: 0 10px;
}

.el-button {
    padding: 12px 35px;
    font-size: 16px;
}

.el-button--primary {
    background: linear-gradient(90deg, #2193b0, #6dd5ed);
    border: none;
}

.el-button--primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(33, 147, 176, 0.3);
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
    .complaint-system {
        padding: 15px;
    }

    .complaint-container {
        padding: 30px;
    }

    .type-title {
        font-size: 20px;
    }

    .section-title {
        font-size: 16px;
    }

    .form-section {
        padding: 20px;
    }

    .el-form-item {
        padding: 0 5px;
    }
}

/* 添加上传组件样式 */
.upload-demo {
    margin-top: 10px;
}

.el-upload__tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
}

/* 复购和退款选项的特殊样式 */
.el-select-dropdown__item {
    padding: 0 20px;
}

.el-select .el-select {
    width: 100%;
    margin: 5px 0;
}

.el-select .el-input {
    width: 100%;
    margin: 5px 0;
}

.radio-group {
    display: flex;
    gap: 40px;
    padding: 8px 0;
}

.radio-group .el-radio {
    margin-right: 0;
}

/* 表单控件样式优化 */
.el-select .el-input__inner,
.el-date-picker .el-input__inner {
    border-radius: 4px;
}

.el-form-item {
    margin-bottom: 22px !important;
    padding: 0 10px;
}

.el-form-item__label {
    font-weight: normal;
    color: #606266;
}

.el-form-item.is-required .el-form-item__label:before {
    color: #f56c6c;
}

/* 调整表单项间距 */
.el-form-item {
    margin-bottom: 22px !important;
    padding: 0 10px;
}

/* 调整表单区块的内边距 */
.form-section {
    margin-bottom: 10px;
    padding: 10px;  /* 减小表单区块的内边距 */
    background: #f8fafc;
    border-radius: 10px;
    border: 1px solid #eef2f7;
}

/* 调整输入框样式 */
.el-input__inner,
.el-textarea__inner {
    padding: 0 15px;
    height: 40px;
    line-height: 40px;
}

.el-textarea__inner {
    padding: 10px 15px;
    min-height: 80px;
}

/* 调整下拉选择框样式 */
.el-select {
    width: 100%;
    margin: 0;
}

/* 调整单选按钮组样式 */
.radio-group {
    display: flex;
    gap: 40px;
    padding: 8px 0;
}

/* 调整日期选择器样式 */
.el-date-picker,
.el-time-picker {
    width: 100%;
}

/* 嵌套表单项的样式 */
.el-form-item .el-form-item {
    margin-bottom: 15px !important;
    margin-top: 15px;
}

/* 最后一个表单项去掉底部间距 */
.form-section .el-form-item:last-child {
    margin-bottom: 0 !important;
}

/* 表单区块标题和内容的间距 */
.section-title {
    margin-bottom: 25px;
}

/* 调整按钮区域的间距 */
.form-actions {
    margin-top: 50px;
    padding: 0 10px;
}

/* 调整表单容器的内边距 */
.complaint-container {
    padding: 50px;
}

/* 级联选择器样式优化 */
.custom-cascader {
    width: 100%;
}

.custom-cascader .el-input__inner {
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
}

/* 额外字段样式 */
.extra-fields {
    margin-top: 20px;
    padding: 15px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #dcdfe6;
}

/* 级联面板样式优化 */
:deep(.el-cascader-panel) {
    .el-cascader-menu__wrap {
        height: auto;
        max-height: 300px;
    }

    .el-cascader-menu__item {
        padding: 10px 20px;

        &:hover {
            background-color: #f5f7fa;
        }

        &.is-active {
            color: #2193b0;
            background-color: #ecf5ff;
        }
    }
}

.status-fields {
    margin-top: 20px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #e4e7ed;
}

.sub-fields {
    margin-top: 15px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #e4e7ed;
}

.el-checkbox-group {
    display: flex;
    gap: 30px;
}

.el-rate {
    margin-top: 8px;
}

/* 物流信息标签页样式 */
.el-tabs--card>.el-tabs__header {
    border-bottom: none;
    margin-bottom: 15px;
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
    border-radius: 4px 4px 0 0;
    transition: all 0.3s;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background: #2193b0;
    border-color: #2193b0;
    color: #fff;
}

.el-tabs__content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 查询按钮样式 */
.el-input-group__append .el-button {
    background: #2193b0;
    color: #fff;
    border: none;
    padding: 0 15px;
}

.el-input-group__append .el-button:hover {
    background: #1a5f7a;
}

.logistics-list {
    margin-bottom: 20px;
}

.list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.list-header h3 {
    margin: 0;
    font-size: 16px;
    color: #606266;
}

.delete-btn {
    color: #f56c6c;
}

.delete-btn:hover {
    color: #f78989;
}

.el-table {
    margin-bottom: 20px;
}

/* 添加新样式 */
.dialog-section {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ebeef5;
}

.dialog-section:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.section-subtitle {
    font-size: 14px;
    color: #606266;
    font-weight: bold;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 3px solid #2193b0;
}

/* 调整对话框宽度和样式 */
.el-dialog {
    max-width: 90%;
}

.el-dialog__body {
    padding: 20px 30px;
}

/* 添加上传组件的样式 */
.upload-evidence {
    :deep(.el-upload--picture-card) {
        width: 148px;
        height: 148px;
        line-height: 148px;
    }

    :deep(.el-upload-list--picture-card .el-upload-list__item) {
        width: 50px;
        height: 148px;
    }

}

.el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 8px;
}

/* 上传按钮样式 */
.upload-btn {
    display: inline-block;
}

.upload-btn .el-button {
    margin: 0;
}

/* 添加凭证内容样式 */
.evidence-content {
    padding: 20px;
    background: #f8fafc;
    border-radius: 8px;
}

.upload-evidence {
    margin-top: 10px;
}

/* 表格头部样式 */
.table-header {
    display: none;
}

/* 新增凭证按钮样式 */
.add-evidence-btn {
    padding: 8px 15px;
    font-size: 12px;
    background-color: #2193b0;
    border-color: #2193b0;
}

.add-evidence-btn:hover {
    background-color: #1a5f7a;
    border-color: #1a5f7a;
}

/* 新增物流按钮样式 */
.add-logistics-btn {
    padding: 8px 15px;
    font-size: 12px;
    background-color: #2193b0;
    border-color: #2193b0;
    margin-left: auto;
}

.add-logistics-btn:hover {
    background-color: #1a5f7a;
    border-color: #1a5f7a;
}

/* 标题栏样式 */
.section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.section-title i {
    margin-right: 8px;
    font-size: 16px;
    color: #2193b0;
}

.section-title span {
    margin-right: auto;
    /* 让标题文字和按钮之间有足够空间 */
}

/* 自动完成输入框样式 */
.el-autocomplete {
    width: 100%;
}

.el-autocomplete-suggestion li {
    padding: 8px 12px;
}

/* 自动完成输入框的建议项样式 */
.suggestion-item {
    padding: 8px 0;
}

.el-autocomplete {
    width: 100%;
}

.el-autocomplete-suggestion li {
    line-height: normal;
    padding: 8px 12px;
}

/* 确保同一行的表单区域高度一致 */
.el-row .form-section {
    height: 100%;
    margin-bottom: 0;
    padding: 15px;
}

/* 调整radio按钮组的布局 */
.radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/* 优化级联选择器在一行中的显示 */
.custom-cascader {
    width: 100%;
}

/* 添加行间距 */
.form-row {
    margin-bottom: 10px !important;
    /* 使用 !important 确保样式生效 */
}

.form-row:last-child {
    margin-bottom: 0;
    /* 最后一行不需要底部间距 */
}

.equal-height {
    height: 100%;
    min-height: 200px;
    /* 增加最小高度 */
    display: flex;
    flex-direction: column;
}

.form-section {
    background-color: #f5f7fa;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    height: 100%;
    /* 确保高度填充 */
}

.section-title {
    margin-bottom: 20px;
    /* 增加标题底部间距 */
}

.el-form-item {
    margin-bottom: 22px;
    /* 调整表单项间距 */
}

/* 表格相关样式 */
.el-table {
    width: 100% !important;
    margin-bottom: 20px;
}

/* 表格单元格居中 */
.table-cell-center {
    text-align: center !important;
}

/* 表格头部样式 */
.el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 500;
    padding: 12px 0;
    text-align: center !important;
}

/* 表格行样式 */
.el-table td {
    padding: 12px 0;
}

/* 表格容器样式 */
.evidence-content {
    padding: 0;
    width: 100%;
    box-sizing: border-box;
}

/* 确保表格填充满容器 */
.el-table__body,
.el-table__header {
    width: 100% !important;
}

.el-table__body-wrapper,
.el-table__header-wrapper {
    width: 100% !important;
}

/* 表格相关样式 */
.evidence-content .el-table {
    width: 100% !important;
}

/* 表格单元格居中 */
.evidence-content .el-table .cell {
    text-align: center !important;
}

/* 表格头部居中 */
.evidence-content .el-table th {
    text-align: center !important;
    background-color: #f5f7fa !important;
}

/* 表格行居中 */
.evidence-content .el-table td {
    text-align: center !important;
}

/* 确保表格填充满容器 */
.evidence-content .el-table__body,
.evidence-content .el-table__header {
    width: 100% !important;
}

.evidence-content .el-table__body-wrapper,
.evidence-content .el-table__header-wrapper {
    width: 100% !important;
}

/* 移除表格外边距 */
.evidence-content {
    padding: 0;
    width: 100%;
    box-sizing: border-box;
}

/* 表格相关样式 */
.el-table {
    width: 100% !important;
}

/* 表格单元格居中 */
.el-table .cell {
    text-align: center !important;
}

/* 表格头部居中 */
.el-table th {
    text-align: center !important;
    background-color: #f5f7fa !important;
}

/* 表格行居中 */
.el-table td {
    text-align: center !important;
}

/* 确保表格填充满容器 */
.el-table__body,
.el-table__header {
    width: 100% !important;
}

.el-table__body-wrapper,
.el-table__header-wrapper {
    width: 100% !important;
}

/* 移除表格外边距 */
.el-table {
    margin: 0;
    width: 100% !important;
}

/* 表格统一样式 */
.el-table {
    width: 100% !important;
}

.el-table>>>.cell {
    text-align: center !important;
}

.el-table>>>th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 500;
    text-align: center !important;
}

.el-table>>>td {
    text-align: center !important;
}

/* 删除其他重复的表格样式... */

/* 添加这些更强的选择器 */
.evidence-content>>>.el-table .cell {
    text-align: center !important;
}

.evidence-content>>>.el-table th.is-leaf {
    text-align: center !important;
}

.evidence-content>>>.el-table td {
    text-align: center !important;
}

/* 使用 /deep/ 或 ::v-deep */
.evidence-content ::v-deep .el-table .cell {
    text-align: center !important;
}

.evidence-content ::v-deep .el-table th.is-leaf {
    text-align: center !important;
}

.evidence-content ::v-deep .el-table td {
    text-align: center !important;
}

/* 问题描述和营销团队 */
.form-row.compact-section {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.form-section-compact {
    width: calc(50% - 10px);
    margin-bottom: 20px;
}

.section-title-compact {
    font-size: 16px;
    color: #1a5f7a;
    font-weight: 500;
    margin-bottom: 15px;
}

.section-title-compact i {
    margin-right: 6px;
    font-size: 16px;
    color: #2193b0;
}

/* 紧凑型表单区域样式 */
.form-section-compact {
    background-color: #f5f7fa;
    padding: 10px 15px;
    /* 减小内边距 */
    border-radius: 4px;
    margin-bottom: 10px;
    /* 减小底部间距 */
}

.section-title-compact {
    margin-bottom: 10px;
    /* 减小标题底部间距 */
    font-size: 14px;
    /* 可选：减小标题字体大小 */
}

/* 紧凑型行样式 */
.compact-section {
    margin-bottom: 15px !important;
    /* 减小行间距 */
}

/* 调整表单项在紧凑型区域中的间距 */
.form-section-compact .el-form-item {
    margin-bottom: 10px;
    /* 减小表单项间距 */
}

/* 确保最后一个表单项没有底部间距 */
.form-section-compact .el-form-item:last-child {
    margin-bottom: 0;
}

/* 删除之前的 form-section-compact 相关样式 */

/* 表单行样式 */
.form-row {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

/* 表单项样式 */
.el-form-item {
    margin-bottom: 0;
}

/* 确保输入框和级联选择器宽度一致 */
.el-textarea,
.el-cascader {
    width: 100%;
}

/* 调整标签宽度，使两边对齐 */
.el-form-item__label {
    width: 120px !important;
}

/* 时间选择器行样式 */
.time-row {
    background-color: #f5f7fa;
    padding: 8px 15px;
    /* 减小上下内边距 */
    border-radius: 4px;
    margin-bottom: 20px;
}

/* 调整时间选择器表单项的间距 */
.time-row .el-form-item {
    margin-bottom: 0;
    /* 移除底部间距 */
}

/* 调整日期选择器的高度 */
.time-row .el-date-picker {
    height: 32px;
    /* 减小日期选择器的高度 */
}

/* 调整表单项标签的行高 */
.time-row .el-form-item__label {
    line-height: 32px;
    /* 减小标签的行高 */
}

/* 调整表单项内容的行高 */
.time-row .el-form-item__content {
    line-height: 32px;
    /* 减小内容的行高 */
}

/* 移除整行的背景色 */
.time-row {
    margin-bottom: 20px;
}

/* 时间输入框包装器样式 */
.time-input-wrapper {
    background-color: #f5f7fa;
    border-radius: 4px;
    padding: 4px 8px;
}

/* 调整表单项的间距 */
.time-row .el-form-item {
    margin-bottom: 0;
}

/* 调整日期选择器的样式 */
.time-row .el-date-picker {
    width: 100%;
}

/* 移除日期选择器的边框 */
.time-input-wrapper .el-input__inner {
    border: none;
    background: transparent;
}

/* 调整标签和内容的行高 */
.time-row .el-form-item__label,
.time-row .el-form-item__content {
    line-height: 32px;
}

/* 调整表单项的整体样式 */
.el-form-item {
    margin-bottom: 8px !important;
    /* 减少表单项之间的间距 */
}

/* 调整标签和输入框的行高 */
.el-form-item__label,
.el-form-item__content {
    line-height: 28px !important;
    /* 减少行高 */
    padding: 0 !important;
    /* 移除内边距 */
}

/* 调整输入框的高度 */
.el-input__inner,
.el-select .el-input__inner,
.el-cascader .el-input__inner {
    height: 28px !important;
    /* 减少输入框高度 */
    line-height: 28px !important;
}

/* 调整单选按钮组的行高 */
.el-radio {
    line-height: 28px !important;
    margin-right: 15px !important;
    /* 适当调整单选按钮之间的间距 */
}

/* 调整下拉选择器的高度 */
.el-select {
    line-height: 28px !important;
}

/* 调整级联选择器的高度 */
.el-cascader {
    line-height: 28px !important;
}

/* 调整表单区域的内边距 */
.form-section {
    padding: 10px 15px !important;
    /* 减少区域内边距 */
}

/* 调整区域标题的底部间距 */
.section-title {
    margin-bottom: 8px !important;
    /* 减少标题底部间距 */
}

/* 调整时间选择器的样式 */
.time-input-wrapper {
    padding: 2px 8px !important;
    /* 减少时间选择器的内边距 */
}

.time-input-wrapper .el-date-picker {
    height: 28px !important;
}

/* 添加表单容器样式 */
.form-container {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 5px;
    /* 将内边距从20px减小到5px */
    margin: 0 5px;
    /* 左右边距也相应减小 */
}



/* 调整表单区域样式 */
.form-section {
    background-color: #f5f7fa;
    padding: 5px 10px;
    /* 减小内边距 */
    border-radius: 4px;
    margin-bottom: 5px;
    /* 减小底部间距 */
}

/* 调整表单行的间距 */
.form-row {
    margin-bottom: 5px;
    /* 减小行间距 */
}

/* 调整栅格系统的间距 */
.el-row {
    margin-left: -5px !important;
    margin-right: -5px !important;
}

.el-col {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

/* 调整时间选择器区域的内边距 */
.time-row {
    padding: 5px;
    margin-bottom: 5px;
}

/* 调整区域标题的底部间距 */
.section-title {
    margin-bottom: 5px;
}

/* 移除form-section的背景色 */
.form-section {
    padding: 0px;
    border-radius: 4px;
    margin-bottom: 5px;
    margin: 0px;
}

/* 添加内容区域的背景色 */
.form-content-wrapper {
    background-color: #f5f7fa;
    border-radius: 4px;
    padding: 5px 10px;
}

/* 调整标题样式 */
.section-title {
    margin-bottom: 5px;
    padding: 0 5px;
    /* 给标题添加少许内边距 */
    font-size: 14px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 5px;
}

/* 调整表单项样式 */
.form-content-wrapper .el-form-item {
    margin-bottom: 5px;
}

.form-content-wrapper .el-form-item:last-child {
    margin-bottom: 0;
}

/* 时间选择器禁用状态样式 */
.time-input-wrapper .el-input.is-disabled .el-input__inner {
    color: #606266;
    /* 保持文字颜色清晰可见 */
    background-color: #f5f7fa;
    cursor: not-allowed;
}
:deep(.el-upload-list--picture-card) {
  display: inline-flex;
  gap: 8px;
}

/* 凭证弹窗样式 */
.pz-content {
    margin-top: 20px;
}

.upload-evidence {
    margin-top: 20px;
}

.el-upload__tip {
    margin-top: 10px;
    color: #909399;
}

/* 表格样式 */
.el-table {
    margin-bottom: 20px;
}

/* 确保表格内容居中对齐 */
.el-table th,
.el-table td {
    text-align: center;
}

.upload-drop-zone {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    /* 设置图片之间的间距 */
    padding: 8px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background: #fff;
    min-height: 148px;
    /* 最小高度 */
    width: 100%;
    /* 容器宽度占满 */
}

.upload-drop-zone.is-dragover {
    border-color: #409EFF;
    background: #f5f7fa;
}

/* 上传按钮样式 */
.upload-evidence {
    display: inline-block;
}

.upload-evidence .el-upload {
    display: block;
}

.upload-evidence .el-upload--picture-card {
    width: 148px;
    height: 148px;
    margin: 0;
    border: 1px dashed #d9d9d9;
}

/* 上传列表样式 */
.el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 148px;
    height: 148px;
    margin: 0;
}

/* 提示文字样式 */
.upload-tip {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    font-size: 12px;
    color: #909399;
    text-align: center;
}

/* 上传内容样式 */
.upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.upload-content i {
    font-size: 28px;
    color: #8c939d;
}

/* 添加预览对话框样式 */
.el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog {
    margin: 0 !important;
    max-width: 90%;
    max-height: 90vh;
}

.el-dialog img {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
}

/* 上传区域样式优化 */
.upload-evidence .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.upload-evidence .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}

/* 优化预览对话框样式 */
.preview-dialog {
    .el-dialog {
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 90%;
        max-height: 90vh;
    }

    .el-dialog__body {
        padding: 10px;
        text-align: center;
    }

    img {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
    }
}

/* 优化上传列表中的预览图标样式 */
.upload-evidence .el-upload-list__item-actions {
    cursor: pointer;
}

.upload-evidence .el-icon-zoom-in {
    font-size: 20px;
    color: #fff;
}

.file-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 4px 0;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #edf2fc;
    transition: all 0.3s;
    border: 1px solid #e6ebf5;
}

.file-item:hover {
    background-color: #ecf5ff;
    border-color: #d9ecff;
}

.file-item i {
    color: #909399;
    font-size: 16px;
    margin-right: 4px;
}

.file-link {
    margin: 0;
    padding: 0;
    color: #409EFF;
    font-size: 13px;
    flex: 1;
   
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-link:hover {
    color: #66b1ff;
    text-decoration: underline;
}

.file-separator {
    color: #909399;
    margin: 0 4px;
}

/* 添加问题描述相关样式 */
.description-section {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.description-textarea {
    width: 100%;
}

/* 调整文本域的样式 */
.description-textarea :deep(.el-textarea__inner) {
    padding: 10px 15px;
    line-height: 1.6;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;
}

/* 悬停和焦点状态 */
.description-textarea :deep(.el-textarea__inner:hover),
.description-textarea :deep(.el-textarea__inner:focus) {
    border-color: #409EFF;
}

/* 确保文本域在表单中的对齐 */
.el-form-item.is-required .el-form-item__label::before {
    margin-right: 4px;
}

/* 修改上传拖拽区域的尺寸 */
:deep(.el-upload-dragger) {
  width: 160px !important;  /* 原来的一半 */
  height: 160px !important;  /* 原来的一半 */
  padding: 10px;
}

/* 修改上传组件的尺寸 */
.upload-evidence {
  :deep(.el-upload--picture-card) {
    width: 50px;
    height: 50px;
    line-height: 40px;
  }

  :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 50px;
    height: 50px;
  }
}

/* 调整上传区域的样式 */
.upload-drop-zone {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fff;
  min-height: 100px;
  width: 100%;
}

/* 调整上传内容区域的样式 */
.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 调整图标大小 */
.upload-content i {
  font-size: 20px;
  color: #8c939d;
  margin-bottom: 5px;
}

/* 调整上传文字提示的样式 */
.el-upload__text {
  font-size: 12px;
  color: #606266;
}

/* 添加统一的标签样式 */
:deep(.el-form-item__label) {
  color: #1a5f7a !important;  /* 更新为新的颜色 */
}

/* 图标样式 */
.el-form-item__label i {
  color: #1a5f7a;
  margin-right: 5px;
}




/* ... 其他样式 ... */

/* 调整按钮区域的样式 */
.form-actions {
    text-align: center;
    margin-top: 15px;
    padding: 0 10px;
}

.el-button {
    padding: 8px 25px;  /* 减小按钮的内边距 */
    font-size: 14px;  /* 减小按钮文字大小 */
    height: 32px;  /* 设置按钮高度 */
    line-height: 16px;  /* 调整文字行高 */
}

.el-button--primary {
    background: linear-gradient(90deg, #2193b0, #6dd5ed);
    border: none;
}

/* 调整整体容器的间距 */
.complaint-system {
    padding: 0;
}

.form-container {
    margin: 0;
}

/* 调整表单项的间距 */
.form-row {
    margin: 0;
    padding: 0;
}

/* 调整表单项内部间距 */
.el-form-item {
   padding: 0;
   margin: 0;
}

/* 调整时间相关行的间距 */
.time-row {
    margin: 0;
    padding: 0;
}

/* 调整描述区域的间距 */
.description-section {
    padding: 0;
    margin: 0;
}

/* 调整上传区域的间距 */
.upload-drop-zone {
    padding: 0;
    gap: 0;
}

/* 调整按钮区域的间距 */
.form-actions {
    margin: 0;
    padding: 0;
}



/* 移除form-section的边距 */
.form-section {
    padding: 0;
    margin: 0;
    border-radius: 0;
}

/* 调整el-row的间距 */
.el-row {
    margin: 0 !important;
}

/* 调整el-col的间距 */
.el-col {
    padding: 0 !important;
}

/* 添加内容区域的背景色 */
.form-content-wrapper {
    background-color: #f5f7fa;
    border-radius: 4px;
    padding: 5px 10px;
}

/* 调整标题样式 */
.section-title {
    margin-bottom: 5px;
    padding: 0 5px;
    /* 给标题添加少许内边距 */
    font-size: 14px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 5px;
}

/* 调整表单项样式 */
.form-content-wrapper .el-form-item {
    margin-bottom: 5px;
}

.form-content-wrapper .el-form-item:last-child {
    margin-bottom: 0;
}

/* 时间选择器禁用状态样式 */
.time-input-wrapper .el-input.is-disabled .el-input__inner {
    color: #606266;
    /* 保持文字颜色清晰可见 */
    background-color: #f5f7fa;
    cursor: not-allowed;
}
:deep(.el-upload-list--picture-card) {
  display: inline-flex;
  gap: 8px;
}

/* 凭证弹窗样式 */
.pz-content {
    margin-top: 20px;
}

.upload-evidence {
    margin-top: 20px;
}

.el-upload__tip {
    margin-top: 10px;
    color: #909399;
}

/* 表格样式 */
.el-table {
    margin-bottom: 20px;
}

/* 确保表格内容居中对齐 */
.el-table th,
.el-table td {
    text-align: center;
}

.upload-drop-zone {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    /* 设置图片之间的间距 */
    padding: 8px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background: #fff;
    min-height: 148px;
    /* 最小高度 */
    width: 100%;
    /* 容器宽度占满 */
}

.upload-drop-zone.is-dragover {
    border-color: #409EFF;
    background: #f5f7fa;
}

/* 上传按钮样式 */
.upload-evidence {
    display: inline-block;
}

.upload-evidence .el-upload {
    display: block;
}

.upload-evidence .el-upload--picture-card {
    width: 148px;
    height: 148px;
    margin: 0;
    border: 1px dashed #d9d9d9;
}

/* 上传列表样式 */
.el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 148px;
    height: 148px;
    margin: 0;
}

/* 提示文字样式 */
.upload-tip {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    font-size: 12px;
    color: #909399;
    text-align: center;
}

/* 上传内容样式 */
.upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.upload-content i {
    font-size: 28px;
    color: #8c939d;
}

/* 添加预览对话框样式 */
.el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-dialog {
    margin: 0 !important;
    max-width: 90%;
    max-height: 90vh;
}

.el-dialog img {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
}

/* 上传区域样式优化 */
.upload-evidence .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.upload-evidence .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}

/* 优化预览对话框样式 */
.preview-dialog {
    .el-dialog {
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 90%;
        max-height: 90vh;
    }

    .el-dialog__body {
        padding: 10px;
        text-align: center;
    }

    img {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
    }
}

/* 优化上传列表中的预览图标样式 */
.upload-evidence .el-upload-list__item-actions {
    cursor: pointer;
}

.upload-evidence .el-icon-zoom-in {
    font-size: 20px;
    color: #fff;
}

.file-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 4px 0;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #edf2fc;
    transition: all 0.3s;
    border: 1px solid #e6ebf5;
}

.file-item:hover {
    background-color: #ecf5ff;
    border-color: #d9ecff;
}

.file-item i {
    color: #909399;
    font-size: 16px;
    margin-right: 4px;
}

.file-link {
    margin: 0;
    padding: 0;
    color: #409EFF;
    font-size: 13px;
    flex: 1;
    
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-link:hover {
    color: #66b1ff;
    text-decoration: underline;
}

.file-separator {
    color: #909399;
    margin: 0 4px;
}

/* 添加问题描述相关样式 */
.description-section {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.description-textarea {
    width: 100%;
}

/* 调整文本域的样式 */
.description-textarea :deep(.el-textarea__inner) {
    padding: 10px 15px;
    line-height: 1.6;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;
}

/* 悬停和焦点状态 */
.description-textarea :deep(.el-textarea__inner:hover),
.description-textarea :deep(.el-textarea__inner:focus) {
    border-color: #409EFF;
}

/* 确保文本域在表单中的对齐 */
.el-form-item.is-required .el-form-item__label::before {
    margin-right: 4px;
}

/* 修改上传拖拽区域的尺寸 */
:deep(.el-upload-dragger) {
  width: 160px !important;  /* 原来的一半 */
  height: 160px !important;  /* 原来的一半 */
  padding: 10px;
}

/* 修改上传组件的尺寸 */
.upload-evidence {
  :deep(.el-upload--picture-card) {
    width: 50px;
    height: 50px;
    line-height: 40px;
  }

  :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 50px;
    height: 50px;
  }
}

/* 调整上传区域的样式 */
.upload-drop-zone {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fff;
  min-height: 100px;
  width: 100%;
}

/* 调整上传内容区域的样式 */
.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 调整图标大小 */
.upload-content i {
  font-size: 20px;
  color: #8c939d;
  margin-bottom: 5px;
}

/* 调整上传文字提示的样式 */
.el-upload__text {
  font-size: 12px;
  color: #606266;
}

/* 添加统一的标签样式 */
:deep(.el-form-item__label) {
  color: #1a5f7a !important;  /* 更新为新的颜色 */
}

/* 图标样式 */
.el-form-item__label i {
  color: #1a5f7a;
  margin-right: 5px;
}




/* ... 其他样式 ... */

/* 调整按钮区域的样式 */
.form-actions {
    text-align: center;
    margin-top: 15px;
    padding: 0 10px;
}

.el-button {
    padding: 8px 25px;  /* 减小按钮的内边距 */
    font-size: 14px;  /* 减小按钮文字大小 */
    height: 32px;  /* 设置按钮高度 */
    line-height: 16px;  /* 调整文字行高 */
}

.el-button--primary {
    background: linear-gradient(90deg, #2193b0, #6dd5ed);
    border: none;
}

/* 调整整体容器的间距 */
.complaint-system {
    padding: 15px;
}

.form-container {
    margin: 15px 0;
}

/* 调整表单项的间距 */
.form-row {
    margin-bottom: 10px;
    padding: 0px;
}

/* 调整表单项内部间距 */
.el-form-item {
   padding: 0px;
}

/* 调整时间相关行的间距 */
.time-row {
    margin: 10px 0;
}

/* 调整描述区域的间距 */
.description-section {
    padding: 0px;
   
}

/* 调整上传区域的间距 */
.upload-drop-zone {
    padding: 2px;
    gap: 2px;
}

/* 调整按钮区域的间距 */
.form-actions {
    margin-top: 10px;
    padding: 0 5px;
}




/* ... 其他样式保持不变 ... */
/* 优化整体布局 */
.complaint-system {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

/* 优化标题样式 */
.page-title {
  margin-bottom: 10px !important;
  font-size: 30px !important;
  color: #2193b0 !important;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  text-align: center;
}

/* 优化表单容器 */
.form-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 优化表单行 */
.form-row {
  margin-bottom: 15px;
}

/* 优化表单项标签 */
.el-form-item__label {
  font-weight: 500;
  color: #333;
}

/* 优化输入框样式 */
.el-input__inner,
.el-select__inner,
.el-cascader__inner {
  border-radius: 4px;
  transition: border-color 0.3s;
}

.el-input__inner:focus,
.el-select__inner:focus,
.el-cascader__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 优化按钮样式 */
.el-button {
  border-radius: 4px;
  transition: all 0.3s;
}

.el-button:hover {
  opacity: 0.9;
}

/* 优化表格样式 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.el-table th {
  background-color: #f7f7f7;
  font-weight: 500;
}

.el-table tr:hover {
  background-color: #f5f7fa;
}

/* 优化对话框样式 */
.el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.el-dialog__header {
  background-color: #f7f7f7;
}

/* 优化标签页样式 */
.el-tabs__nav {
  margin-bottom: 15px;
}

.el-tabs__tab {
  padding: 0 16px;
}

.el-tabs__tab.is-active {
  color: #1890ff;
}

.el-tabs__active-bar {
  background-color: #1890ff;
}

/* 优化上传组件 */
.el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
}

/* 优化时间选择器 */
.el-date-editor .el-input {
  width: 100%;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .el-col {
    width: 100% !important;
  }
}
</style>
